import _ from 'lodash'
import * as gallery from '../images/gallery/*'
import toHomeBtn from '../images/to-home.png'

const data = {
  'home1-45547': {
    caption: '明 透雕蟠龙花卉犀角杯',
    thumbnail: gallery['home1-45547-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-45547-1.jpg'],
        points: []
      }
    ]
  },
  'home1-45546': {
    caption: '清 朱彝尊肖像端砚',
    thumbnail: gallery['home1-45546-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-45546-1.jpg'],
        points: []
      }
    ]
  },
  'home1-45543': {
    caption: '西周中期 凤龙纹玉饰',
    thumbnail: gallery['home1-45543-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-45543-1.jpg'],
        points: []
      }
    ]
  },
  'home1-54646': {
    caption: '夏 玉璋',
    thumbnail: gallery['home1-54646-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-54646-1.jpg'],
        points: []
      }
    ]
  },
  'home1-54633': {
    caption: '新石器时代 玉璧',
    thumbnail: gallery['home1-54633-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-54633-1.jpg'],
        points: []
      }
    ]
  },
  'home1-54630': {
    caption: '商 玉戚',
    thumbnail: gallery['home1-54630-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-54630-1.jpg'],
        points: []
      }
    ]
  },
  'home1-54647': {
    caption: '新石器时代 玉刀',
    thumbnail: gallery['home1-54647-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-54647-1.jpg'],
        points: []
      }
    ]
  },
  'home1-54655': {
    caption: '新石器时代 玉琮',
    thumbnail: gallery['home1-54655-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-54655-1.jpg'],
        points: []
      }
    ]
  },
  'home1-64644': {
    caption: '新石器时代 玉环',
    thumbnail: gallery['home1-64644-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-64644-1.jpg'],
        points: []
      }
    ]
  },
  'home1-8108': {
    caption: '西周晚期 趞曹鼎',
    thumbnail: gallery['home1-8108-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-8108-1.jpg'],
        points: []
      }
    ]
  },
  'home1-2563': {
    caption: '西周中期 趞曹鼎',
    thumbnail: gallery['home1-2563-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-2563-1.jpg'],
        points: []
      }
    ]
  },
  'home1-23561': {
    caption: '春秋晚期 者뇾钟',
    thumbnail: gallery['home1-23561-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-23561-1.jpg'],
        points: []
      }
    ]
  },
  'home1-26397': {
    caption: '西周中期 师뀐父鼎',
    thumbnail: gallery['home1-26397-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-26397-1.jpg'],
        points: []
      }
    ]
  },
  'home1-39416': {
    caption: '宋人 夜合花图纨扇页',
    thumbnail: gallery['home1-39416-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-39416-1.jpg'],
        points: []
      }
    ]
  },
  'home1-45511': {
    caption: '清 王鉴关山秋霁图轴',
    thumbnail: gallery['home1-45511-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-45511-1.jpg'],
        points: []
      }
    ]
  },
  'home1-64745': {
    caption: '清 金农 隶书六言联轴',
    thumbnail: gallery['home1-64745-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-64745-1.jpg'],
        points: []
      }
    ]
  },
  'home1-64777': {
    caption: '清 任薰 愙斋集古图',
    thumbnail: gallery['home1-64777-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-64777-1.jpg'],
        zoomLevel: 5,
        points: []
      }
    ]
  },
  'home1-64771': {
    caption: '清 金俊明 群芳合璧图册',
    thumbnail: gallery['home1-64771-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-64771-1.jpg'],
        points: []
      }
    ]
  },
  'home1-51064': {
    caption: '明 金湜（款）双钩竹图轴',
    thumbnail: gallery['home1-51064-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-51064-1.jpg'],
        points: []
      }
    ]
  },
  'home1-64517': {
    caption: '近代 吴大澂 “愙斋所得金石”石章',
    thumbnail: gallery['home1-64517-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home1-64517-1.jpg'],
        points: []
      }
    ]
  },
  'home2-2447': {
    caption: '明 董其昌 烟江叠幛图卷',
    thumbnail: gallery['home2-2447-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-2447-1.jpg'],
        zoomLevel: 5,
        points: []
      }
    ]
  },
  'home2-2574': {
    caption: '明 唐寅 春山伴侣图轴',
    thumbnail: gallery['home2-2574-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-2574-1.jpg'],
        points: []
      }
    ]
  },
  'home2-8882': {
    caption: '明 陈淳 山茶水仙图轴',
    thumbnail: gallery['home2-8882-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-8882-1.jpg'],
        points: []
      }
    ]
  },
  'home2-19951': {
    caption: '明 董其昌 栖霞寺诗意图轴',
    thumbnail: gallery['home2-19951-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-19951-1.jpg'],
        points: []
      }
    ]
  },
  'home2-65505': {
    caption: '明 董其昌 山水 陈继儒行书合卷',
    thumbnail: gallery['home2-65505-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-65505-1.jpg'],
        zoomLevel: 5,
        points: []
      }
    ]
  },
  'home2-45532': {
    caption: '明 王建章 山水扇页',
    thumbnail: gallery['home2-45532-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-45532-1.jpg'],
        points: []
      }
    ]
  },
  'home2-59917': {
    caption: '宋拓 梁萧敷敬妃墓志铭合册',
    thumbnail: gallery['home2-59917-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-59917-1.jpg'],
        points: []
      },
      {
        url: gallery['home2-59917-2.jpg'],
        points: []
      },
      {
        url: gallery['home2-59917-3.jpg'],
        points: []
      },
      {
        url: gallery['home2-59917-4.jpg'],
        points: []
      }
    ]
  },
  'home2-59926': {
    caption: '隋 常丑奴墓志铭册',
    thumbnail: gallery['home2-59926-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-59926-1.jpg'],
        points: []
      }
    ]
  },
  'home2-51383': {
    caption: '近代 蒋节“沈树镛印”石章',
    thumbnail: gallery['home2-51383-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home2-51383-1.jpg'],
        points: []
      }
    ]
  },
  'home3-24306': {
    caption: '西周晚期 师꽐簋',
    thumbnail: gallery['home3-24306-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-24306-1.jpg'],
        points: []
      }
    ]
  },
  'home3-34693': {
    caption: '春秋晚期 郘뿬钟',
    thumbnail: gallery['home3-34693-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-34693-1.jpg'],
        points: []
      }
    ]
  },
  'home3-41536': {
    caption: '春秋晚期 沇儿钟',
    thumbnail: gallery['home3-41536-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-41536-1.jpg'],
        points: []
      }
    ]
  },
  'home3-15234': {
    caption: '西周晚期 仲义父믉',
    thumbnail: gallery['home3-15234-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-15234-1.jpg'],
        points: []
      }
    ]
  },
  'home3-2809': {
    caption: '西周晚期 师닄簋',
    thumbnail: gallery['home3-2809-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-2809-1.jpg'],
        points: []
      }
    ]
  },
  'home3-8105': {
    caption: '西周晚期 井人둍钟',
    thumbnail: gallery['home3-8105-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-8105-1.jpg'],
        points: []
      }
    ]
  },
  'home3-8106': {
    caption: '西周中期 小克鼎',
    thumbnail: gallery['home3-8106-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-8106-1.jpg'],
        points: []
      }
    ]
  },
  'home3-8107': {
    caption: '西周中期 克钟',
    thumbnail: gallery['home3-8107-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-8107-1.jpg'],
        points: []
      }
    ]
  },
  'home3-21806': {
    caption: '西周中期 师虎簋',
    thumbnail: gallery['home3-21806-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-21806-1.jpg'],
        points: []
      }
    ]
  },
  'home3-15235': {
    caption: '西周晚期 史颂鼎',
    thumbnail: gallery['home3-15235-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-15235-1.jpg'],
        points: []
      }
    ]
  },
  'home3-35361': {
    caption: '西周中期 师遽方彝',
    thumbnail: gallery['home3-35361-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-35361-1.jpg'],
        points: []
      }
    ]
  },
  'home3-3183': {
    caption: '西周中期 大克鼎',
    thumbnail: gallery['home3-3183-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-3183-1.jpg'],
        points: []
      }
    ]
  },
  'home3-44047': {
    caption: '南宋刊 竹友集',
    thumbnail: gallery['home3-44047-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-44047-1.jpg'],
        points: []
      }
    ]
  },
  'home3-44048': {
    caption: '宋刊 乖崖集',
    thumbnail: gallery['home3-44048-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-44048-1.jpg'],
        points: []
      }
    ]
  },
  'home3-59934': {
    caption: '明拓 唐崔敦礼碑册',
    thumbnail: gallery['home3-59934-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-59934-1.jpg'],
        points: []
      }
    ]
  },
  'home3-45534': {
    references: 'home4-45534'
  },
  'home3-35389': {
    caption: '清 赵之谦 “翰林供奉”石章',
    thumbnail: gallery['home3-35389-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['home3-35389-1.jpg'],
        points: []
      }
    ]
  },
  'home4-45511': {
    caption: '清 王鉴关山秋霁图轴',
    thumbnail: gallery['home4-45511-0.jpg'],
    description: '<p>康熙十四年（1675）</p><p>纸本 设色</p><p>王鉴（1598-1677），字圆照，号湘碧，江苏太仓人。清初“四王”之一。此图为其七十八岁所作。</p><p>此作原为吴大澂的收藏，有其题签及题跋。凡祖父旧藏，吴湖帆皆宝爱有加，散佚在外的但凡有能力则悉数购回，此画即是一例。如吴湖帆在裱边的题跋中所言：“吾家旧有物也。壬申（1932）四月自故都购归，永藏什袭。”体现出对祖辈的尊敬，亦是对家藏旧物的珍惜。</p>',
    slides: [
      {
        url: gallery['home4-45511-1.jpg'],
        points: [
          {
            x: 73,
            y: 910,
            content: '<p>吴大澂题跋：“湘碧老人早年多泼墨淋漓之笔，其精细之作皆在六七十岁以后。此幛仿范原华《关山秋霁图》，与予所临《虞山十景》笔意可相引证也。此幅予得之十余年，廉夫屡屡借临，其用意之缜密，虽极小处无一懈笔，即此可见娄东家法也。丙申（1896）夏六月，久病新瘥，展玩再四，信笔题此。白云山樵吴大澂时年六十有二。”</p>'
          },
          {
            x: 1738,
            y: 2082,
            content: '<p>吴湖帆题跋：“王湘碧《关山秋霁图》有先尚书公题字，吾家旧有物也。壬申四月自故都购归，永藏什袭。吴湖帆谨识。”</p>'
          }
        ]
      }
    ]
  },
  'home4-64745': {
    caption: '清 金农 隶书六言联轴',
    thumbnail: gallery['home4-64745-0.jpg'],
    description: '<p>纸本</p><p>金农（1687-1763），字寿门，号冬心等，仁和（今浙江杭州）人。扬州画派画家之一。联语出自《北齐书.鸿勋》。金农后期的八分书，破圆为方，墨浓如漆，后人称之为“漆书”。</p><p>从吴湖帆的裱边题跋可知，此联为其祖吴大澂藏品。跋文字里行间，流露出对祖传藏品的珍惜之情。</p>',
    slides: [
      {
        url: gallery['home4-64745-1.jpg'],
        points: [
          {
            x: 1808,
            y: 503,
            content: '<p>吴大澂题签：“冬心先生对。上。”</p>'
          },
          {
            x: 966,
            y: 492,
            content: '<p>吴大澂题签：“冬心先生对。下。”</p>'
          },
          {
            x: 82,
            y: 2707,
            content: '<p>吴湖帆题跋：“此联犹是祖遗旧藏品。上下二签皆愙斋公亲笔书。湖帆珍藏敬识。”</p>'
          }
        ]
      }
    ]
  },
  'home4-64777': {
    caption: '清 任薰、陆恢 愙斋集古图',
    thumbnail: gallery['home4-64777-0.jpg'],
    description: '<p>纸本 设色</p><p>任薰（1834-1893），字阜长，浙江萧山人。</p><p>陆恢（1851-1920），字廉夫，原籍江苏吴江，居苏州。</p><p>此卷是金石收藏大家、吴湖帆的祖父吴大澂（1835-1902，晚号愙斋）将自己收藏的青铜器全形墨拓而成的图卷，共分上下卷。上下卷分别有海派名家任薰与吴幕府画家陆恢所作《愙斋集古图》，图绘吴大澂观赏其藏品的场景。同时，图中对形制各异的青铜器作了细致逼真的描绘，并为其一一注明名称。从此卷可见吴大澂收藏之富，亦可见吴湖帆之家学渊源。</p>',
    slides: [
      {
        url: gallery['home4-64777-1.jpg'],
        zoomLevel: 5,
        points: []
      },
      {
        url: gallery['home4-64777-2.jpg'],
        points: []
      }
    ]
  },
  'home4-64771': {
    caption: '清 金俊明 群芳合璧图册',
    thumbnail: gallery['home4-64771-0.jpg'],
    description: '<p>顺治十七年（1660）</p><p>纸本 水墨/设色</p><p>金俊明（1602-1675），字孝章，号耿庵，江苏苏州人。此册为作者墨戏自赏之作，作于顺治十七年时年五十九岁之际，画后又请好友一一补缀各种花卉松竹以成。</p><p>此册原为吴湖帆祖父吴大澂、父亲吴本善鉴题递藏旧物，册后尚有吴湖帆父亲讷士吴本善小楷考订册中诸人生平，可见明末清初金俊明的交游圈。</p>',
    slides: [
      {
        url: gallery['home4-64771-1.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-2.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-3.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-4.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-5.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-6.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-7.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-8.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-9.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-10.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-11.jpg'],
        points: []
      },
      {
        url: gallery['home4-64771-12.jpg'],
        points: [
          {
            x: 797,
            y: 200,
            content: '<p>吴湖帆题跋：“吾家旧居双林巷春草闲房，孝章先生故里也。先祖收得先生画梅册凡三，以此为冠。又先生手书诗稿一卷，皆丙戌（1646）、丁亥（1647）时作语，多凄感，盖身世与所南仿佛耳。此册曾装于光绪戊申（1908），先父录作家小传于后，越今又廿余年矣。重付潢池题之，时辛未（1931）十月，吴湖帆。”</p>'
          }
        ]
      },
      {
        url: gallery['home4-64771-13.jpg'],
        points: [
          {
            x: 1878,
            y: 112,
            content: '<p>吴讷士题跋考证页</p>'
          }
        ]
      }
    ]
  },
  'home4-51064': {
    caption: '明 金湜（款）双钩竹图轴',
    thumbnail: gallery['home4-51064-0.jpg'],
    description: '<p>纸本 水墨</p><p>金湜（十五世纪），字本清，号太瘦生，浙江宁波人。正统中举人，善画竹石，篆隶行草，皆有晋人风度。本图太湖石墨染，勾勒的竹枝、竹叶墨色淡雅工丽，浓淡相宜。</p><p>据画轴外签可知，此为吴湖帆祖父吴大澂藏品，当年视若拱璧。故吴湖帆、潘静淑夫妇亦极为珍视，画面迭有鉴赏印记。此轴疑非金氏真迹，待研究。</p>',
    slides: [
      {
        url: gallery['home4-51064-1.jpg'],
        points: [
          {
            x: 1544,
            y: 1099,
            content: '<p>吴大澂题签：“朽木居士竹石，神品。愙斋宝藏”</p>'
          }
        ]
      }
    ]
  },
  'home4-45532': {
    caption: '明 王建章 山水扇页',
    thumbnail: gallery['home4-45532-0.jpg'],
    description: '<p>崇祯十七年（1644）</p><p>金笺 水墨</p><p>王建章（十七世纪），字仲初。</p><p>此扇系吴湖帆外祖沈树镛旧藏。经吴湖帆考证指出：王建章真迹不多，画亦无甚出色，因曾东渡日本，作品流传至日本而被彼人奉为至宝。现存王建章款图扇面貌风格不一，不知者以为建章风格多变，实则“某孝廉”为牟利搜集明人画扇数十箑，去其款而填写建章之名的伪作。而这件王建章款图扇才是王氏作品的真正面貌。</p>',
    slides: [
      {
        url: gallery['home4-45532-1.jpg'],
        points: [
          {
            x: 4506,
            y: 156,
            content: '<p>吴湖帆题跋：王仲初曾东渡日本，遗流真迹一二，故日本知其人而重其画。清季有某孝廉者悉其状，遂搜集明人画之穷款者数十箑(zhá)，悉出其款而填写建章之名。其计大酬，识者乃大惑建章之无所不工而真面莫测也。若某孝廉者，可谓狡矣。此箑(zhá)乃先外租旧藏，与某孝廉之建章不同，庐山真面，愿识者共认。不知瀛海客士见之如何？幸海内藏家勿忽。吴湖帆识。</p>'
          }
        ]
      }
    ]
  },
  'home4-59917': {
    caption: '宋拓 梁萧敷敬妃墓志铭合册',
    thumbnail: gallery['home4-59917-0.jpg'],
    description: '<p>萧敷（？－497），字仲达，南朝齐兰陵（今江苏镇江）人，梁武帝兄。</p><p>本册双志拓本，向来被视为较之史传记载更为详尽的萧敷与敬太妃传世墓志孤本。</p><p>因此册为吴湖帆外祖、晚清沪上金石碑版鉴藏家沈树镛旧藏，故吴湖帆竭力搜访，得之于二十世纪三十年代初期，奉为至宝，题为“墨皇”。并因双志撰者徐勉表字修仁而命斋室名“双修阁”。</p>',
    slides: [
      {
        url: gallery['home4-59917-1.jpg'],
        points: []
      },
      {
        url: gallery['home4-59917-2.jpg'],
        points: [
          {
            x: 1785,
            y: 91,
            content: '<p>吴湖帆题首：“墨皇，吴氏文物至宝之一，宋拓孤本梁永阳昭王、敬太妃双志，双修阁镇宝记”</p>'
          }
        ]
      },
      {
        url: gallery['home4-59917-3.jpg'],
        points: [
          {
            x: 1250,
            y: 269,
            content: '<p>吴湖帆、潘静淑相关题跋：“梁仆射徐勉，字修仁，工文章，当时丰功伟绩之文皆出其制。此永阳王敬太妃双志，咸为修仁奉敕所撰，因名吾室曰：双修阁。癸酉（1933）二月，吴湖帆、潘静淑记。”</p>'
          }
        ]
      },
      {
        url: gallery['home4-59917-4.jpg'],
        points: [
          {
            x: 634,
            y: 269,
            content: '<p>吴湖帆题跋：“此为宋拓孤本第一名流。《旧馆坛碑》已亡，《萧憺》仅余石骼，向为潘氏压箱，名籍海内，今属静淑嗣守，当永保之。吴湖帆谨记。”</p>'
          }
        ]
      }
    ]
  },
  'home4-59926': {
    caption: '隋 常丑奴墓志铭册',
    thumbnail: gallery['home4-59926-0.jpg'],
    description: '<p>纸本 墨拓</p><p>《隋常丑奴墓志铭》全称《隋都督荥泽县令故常府君墓志》，是常氏与妻宗氏合葬志。无撰书人名，原存陕西兴平县崇宁寺壁间，后寺废石佚，拓本遂为世人所重，被奉为唐楷先声。</p><p>本册拓本曾为清扬州画派画家金农旧藏，后由吴湖帆外祖沈韵初、祖父吴大澂递藏，为吴氏自号“丑簃”出处。</p>',
    slides: [
      {
        url: gallery['home4-59926-1.jpg'],
        points: []
      },
      {
        url: gallery['home4-59926-2.jpg'],
        points: [
          {
            x: 230,
            y: 1485,
            content: '<p>丑簃</p>'
          }
        ]
      },
      {
        url: gallery['home4-59926-3.jpg'],
        points: [
          {
            x: 144,
            y: 1134,
            content: '<p>既丑且美</p>'
          }
        ]
      },
      {
        url: gallery['home4-59926-4.jpg'],
        points: [
          {
            x: 1682,
            y: 267,
            content: '<p>吴湖帆题跋：“先外祖沈韵初先生手札一通，因提及《常丑奴》、《董美人》两志，前岁沈湘之表兄收得贻余，即粘于《常志》之前。湖帆谨记。”</p>'
          }
        ]
      }
    ]
  },
  'home4-45534': {
    caption: '南宋 景定二年刊梅花喜神谱',
    thumbnail: gallery['home4-45534-0.jpg'],
    description: '<p>景定二年（1261）</p><p>纸本 雕版印刷</p><p>古称画像为“喜神”，故本谱名称“梅花喜神谱”，即梅花画谱。本谱初刻于南宋嘉熙二年（1238），原刻本未见传世。此为南宋景定二年（1261）金华双桂堂重刊本，宋伯仁编绘，是中国最早的木刻图籍，亦是第一部专门描绘梅花的画谱。此谱按梅花新陈代谢规律，画就不同形态折枝梅花百幅，姿态各异，状物传神，每图题名并配五言绝句，图文并茂，且雕刻恭喜，极富艺术鉴赏价值。</p><p>此谱为吴湖帆岳家潘祖荫祖传善本古籍，吴湖帆对此极为珍视，专门篆刻鉴藏印“吴湖帆潘静淑夫妇所藏海内孤本宋刊梅花喜神谱之印章”。其斋名“梅景书屋”的“梅”字寓意，即因此谱得名。</p>',
    slides: [
      {
        url: gallery['home4-45534-1.jpg'],
        points: [
          {
            x: 244,
            y: 1799,
            content: '<p>吴湖帆、潘静淑题跋：梅花喜神谱二卷</p><p>吴氏梅影书屋珍藏镇宝宋刻宋印本</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-2.jpg'],
        points: []
      },
      {
        url: gallery['home4-45534-3.jpg'],
        points: []
      },
      {
        url: gallery['home4-45534-4.jpg'],
        points: [
          {
            x: 1707,
            y: 1302,
            content: '<p>吴湖帆潘静淑夫妇所藏海内孤本宋刊梅花喜神谱之印章</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-5.jpg'],
        points: [
          {
            x: 1548,
            y: 248,
            content: '<p>吴湖帆、潘静淑题写《梅花喜神谱》册页</p><p>此画为潘静淑绘绿萼梅花图，后经吴湖帆补写红梅。图上另有吴湖帆学生周炼霞题诗。后皆装入《梅花喜神谱》册中。</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-6.jpg'],
        points: [
          {
            x: 1782,
            y: 238,
            content: '<p>潘静淑集文徵明诗句页</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-7.jpg'],
        points: [
          {
            x: 1751,
            y: 200,
            content: '<p>吴湖帆题词</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-8.jpg'],
        points: [
          {
            x: 1736,
            y: 182,
            content: '<p>潘静淑题词</p>'
          }
        ]
      },
      {
        url: gallery['home4-45534-9.jpg'],
        points: [
          {
            x: 1721,
            y: 182,
            content: '<p>周炼霞题写《梅花喜神谱》册页</p><p>《梅花喜神谱》中原有女画家张永芳梅花一帧，因残损，由周炼霞补画此页缀入。另有吴湖帆题诗一首。</p>'
          }
        ]
      }
    ]
  },
  'home4-51079': {
    caption: '唐 佚名 楷书大方广佛华严经卷第卅二',
    thumbnail: gallery['home4-51079-0.jpg'],
    description: '<p>纸本</p><p>本卷为吴家旧藏。内容参见《大正藏》第十卷。原为长卷，后改为四行一折，复又割裂重裱为长卷。</p>',
    slides: [
      {
        url: gallery['home4-51079-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 461,
            y: 387,
            content: '<p>吴湖帆跋释文：“唐人写经卷子，自光绪间甘肃敦煌石室坍发之后，传世遂多，耳濡目染，余所见亦不止数百卷矣。此卷吾家旧藏，非敦煌发现本，其先不知所自出，书法与经文较敦煌本无大出入，惟纸色则传世较古耳。” </p>'
          }
        ]
      }
    ]
  },
  'sight-w00001': {
    caption: '吴湖帆 烛奸录手稿册',
    thumbnail: gallery['sight-w00001-0.jpg'],
    description: '<p>纸本</p><p>这是吴湖帆1935年应伦敦国际艺术展览会之约，检阅故宫博物院所藏书画之鉴定纪录。手稿内容即为吴氏鉴定过程中所记录的伪作。其中较为著名的鉴定意见有：指乾隆数十题跋的黄公望《富春山居图》卷为伪本；范宽《溪山行旅图》轴二幅大小相仿，有董其昌题者为真（台北故宫藏），有王时敏题者疑为王翚摹本（台北故宫藏）等等。</p>',
    slides: [
      {
        url: gallery['sight-w00001-1.jpg'],
        points: []
      }
    ]
  },
  'sight-6651': {
    caption: '北宋 郭熙 幽谷图轴',
    thumbnail: gallery['sight-6651-0.jpg'],
    description: '<p>绢本 水墨</p><p>郭熙（十一世纪），字淳夫，河南温县人。此画为北宋秘府旧藏，著录于《宣和画谱》。</p><p>《丑簃日记》1933年正月记：“大千携示郭河阳《幽谷图》绢本真迹，笔墨生动，百读不厌，载入安仪周《墨缘汇观》中，今在庐山蔡金台家。”二月二日，叶恭绰过访，吴湖帆出示而与之同观。二月十五日，吴湖帆在日记中写道：“临郭熙《幽谷图》一角。”今吴湖帆《临郭熙幽谷图》仍存世。</p>',
    slides: [
      {
        url: gallery['sight-6651-1.jpg'],
        points: []
      }
    ]
  },
  'sight-8857': {
    caption: '五代 董源 夏山图卷',
    thumbnail: gallery['sight-8857-0.jpg'],
    description: '<p>董源，五代南唐画家，南派山水画开山鼻祖。</p><p>此卷曾经吴湖帆外祖沈韵初和庞莱臣递藏，与现藏故宫博物院的董源《潇湘图》卷、美国大都会博物馆的《溪岸图》轴（时皆为张大千收藏），皆曾经吴湖帆过目。在吴氏自绘《潇湘雨过图》轴等自题中屡有提及，“盖一时笔也，笔势雄奇缜密，洵艺林剧迹。”</p><p>吴湖帆十分关注江南一带尤其是沪上大藏家所藏，比如庞莱臣家藏的黄公望《快雪时晴图》卷（现藏故宫）等，吴氏日记虽未一一详列，且庞氏所藏大都亦无吴氏本人题鉴，但据其记载仍可悉知，“余于庞氏画所见十之七八”。</p>',
    slides: [
      {
        url: gallery['sight-8857-1.jpg'],
        zoomLevel: 5,
        points: []
      }
    ]
  },
  'sight-31403': {
    caption: '元 王蒙 青卞隐居图轴',
    thumbnail: gallery['sight-31403-0.jpg'],
    description: '<p>纸本 水墨</p><p>王蒙（1308-1385），字叔明，号黄鹤山樵。吴兴（今浙江湖州）人。“元四家”之一。图绘其家乡吴兴卞山胜景。此图为其传世代表作，至正二十六年，作者时年五十九岁。</p><p>吴湖帆于1935年数次观摩此画，1937年时曾记载狄平子将此宝物藏于海上“金城”（保险柜）中的“廿六号柜”，柜中另有狄氏藏钱选《浮玉山居图》卷等名件，而吴湖帆所藏的本展中吴镇《渔父图》卷则寄存于“廿七号”柜。1944年，吴氏于王蒙此画上题写观款。</p>',
    slides: [
      {
        url: gallery['sight-31403-1.jpg'],
        points: [
          {
            x: 103,
            y: 7931,
            content: '<p>吴湖帆题跋：甲申四月吴湖帆谨观</p>'
          }
        ]
      }
    ]
  },
  'sight-35731': {
    caption: '明 陈楫 虎丘十二景图册',
    thumbnail: gallery['sight-35731-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['sight-35731-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-35731-2.jpg'],
        points: []
      },
      {
        url: gallery['sight-35731-14.jpg'],
        points: [
          {
            x: 1698,
            y: 264,
            content: '<p>吴湖帆题跋考订作者生平：“陈楫，字莱山，号济之，吴郡人。明万历间以画名于时。与王仲山（问）友善，仲山画间出济之捉刀（见故宫周刊仲山山水一幅即陈笔也）。此册之前原有仲山书引首四字及文伯仁画虎阜全景一幅，王文肃、王弇州等数跋（钱余初见时未皆佚），旋被庸工割裂，充市贾酒资矣，不胜惋惜。后此册为张大千兄所见，以吾吴景物购之相赠云，甲戌冬日吴湖帆识。”</p>'
          }
        ]
      },
      {
        url: gallery['sight-35731-15.jpg'],
        points: [
          {
            x: 1818,
            y: 340,
            content: '<p>吴湖帆题跋考证：“陈楫之名不见画史，审其树石极似戴文进、吴小僊。偶参南宗处，大类谢橒仙，人物乃周东邨之余绪，花卉则陈白阳之早年。各派咸具门户。观仲山诸画，知出陈氏手不少，盖其名为仲山所掩，故世传不彰矣。宋人冷画至明季而有人集录，至清末而竟若至宝。安知明人冷画不今日而入敝笈，后日而登锦囊者乎！吾于陈氏《虎阜十二景册》不胜慨叹且珍护焉。惜娄东二王跋之被截与市侩而不得预之。时乙亥（1935）正月二十三日拥炉夜坐遣闷题。”</p>'
          }
        ]
      }
    ]
  },
  'sight-8815': {
    caption: '南宋 赵构 临虞世南真草千字文卷',
    thumbnail: gallery['sight-8815-0.jpg'],
    description: '<p>此卷用笔与辽宁省博物馆藏赵构《洛神赋》卷相合，当为赵构名迹。卷后有高宗题跋押印，则称此卷为唐虞世南真迹。后元明间俞友仁、钱宰及明代收藏家项元汴等题跋，亦皆认为是虞书。吴湖帆收购时亦定为虞书真迹，并对此卷流传做了详尽的考证，其友人叶恭绰、吴梅等皆赞成其说。1937年，吴湖帆根据明人韩逢禧记载，知高宗晚年喜欢摹写晋唐名家真迹并托名颁赐大臣为乐的事迹，再三考辨后将此卷作者改定为宋高宗，展示了其实事求是的学术精神。</p>',
    slides: [
      {
        url: gallery['sight-8815-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 12736,
            y: 472,
            content: '<p>宋高宗题跋： “赐思温”。</p>'
          },
          {
            x: 10914,
            y: 684,
            content: '<p>“虞伯施书翰之绝，殆与晋宋争衡，真草千文，妙冠当代，可谓东南之美也。文皇时作此书，故笔所阙者‘民’、‘渊’二字而已”。</p>'
          },
          {
            x: 10756,
            y: 166,
            content: '<p>印章：白文“真阁”葫芦印</p>'
          },
          {
            x: 10592,
            y: 176,
            content: '<p>吴湖帆题跋：“真阁二字葫芦印乃宋高宗玉玺印也”。</p>'
          },
          {
            x: 9038,
            y: 690,
            content: '<p>俞友仁题跋：“真草千文自隋僧智永所书，妙绝今古，虞伯施临本世亦罕及。余观此帖，非伯施所书，则余亦莫能及也。茍非真本，则思陵安得批赐大臣，而用内府图印以珍重之哉？俞友仁题。”</p>'
          },
          {
            x: 4674,
            y: 303,
            content: '<p>吴湖帆题跋：“此卷宋高宗题为虞伯施真迹，卷末‘赐思温’三字亦思陵御笔，并钤‘御书’印。万历七年为檇李项氏天籁阁所藏，后归安徽吴氏，复以千金归吾吴韩氏，录入《南阳法书表》正书类第五。越五年而归华亭李周生永昌，至清咸丰间乃藏于合肥周氏，又入项城袁文诚公家，余盖得之于袁氏者也。据《南阳法书表》载有宋高宗等跋，尚有元俞、钱二跋。按俞友仁，字文辅，仁和人，工诗书文字，洪武初开科，乡、会试俱列第一人，授长山县丞、山西佥事。徐虹亭《本事诗》记王蒙宫词，仁和俞友仁见之，叹赏曰‘此唐人得意句也’，遂以其妹妻之。钱宰字伯均，又字子予，会稽人，登至正间甲科，负儒名，洪武初征修礼乐，授国子助教，进博士，后命订正《尚书蔡氏传》，书成赐归，有《临安集》。此卷自宋元以来藏庋可考，今为吾家梅景书屋法书冠冕，千年墨宝，长留天壤，应随所至有吉祥云呵护之云，吴湖帆</p>'
          },
          {
            x: 2645,
            y: 876,
            content: '<p>叶恭绰题跋释文：“永兴真迹平生惟见此与《汝南公主志文》，志文怯懦，谓为米摹。尚未敢遽信。曩景朴孙欲以见让，未敢承也。此卷气韵沉厚，似非宋人所能办，明眼人当能辨之。至于绢素印章之识别，抑其次也。其少见公私著录，则明珠偶遗珊网，未可以此遂判真赝。湖帆得此异宝，益为高斋增色矣。叶恭绰获观因志。</p>'
          },
          {
            x: 2146,
            y: 162,
            content: '<p>吴梅题跋：“山谷题《庙堂碑》云：‘孔庙虞书贞观刻，千两黄金哪购得？’此则永兴真迹、绍兴题识，真无价瑰宝矣。湖帆得此沪市，出以见示，自诩眼福可以傲山谷云。庚午七月，霜厓吴梅敬观。”</p>'
          },
          {
            x: 39098,
            y: 153,
            content: '<p>吴湖帆再跋释文：“据韩逢禧《黄庭经》跋云：宋思陵晚岁居德寿宫，每摹写二王及晋唐明贤真迹，托名自跋以赐大臣为乐。吾家所藏如《黄庭经》、虞世南《千文》皆是焉，云云。今审此卷有思陵自跋及‘赐思温’押，可知出思陵为无疑。丁丑（1937）四月。”</p>'
          }
        ]
      }
    ]
  },
  'sight-13756': {
    caption: '明 仇英 右军书扇图轴',
    thumbnail: gallery['sight-13756-0.jpg'],
    description: '<p>纸本 设色</p><p>魏庭荣捐赠</p><p>此《右军书扇图》轴无作者款印，吴湖帆为友人林尔卿鉴定此图，将其与故宫博物院藏仇英《桐阴清话图》和《蕉阴结夏图》二大幅相比对，发现其共同特点为：四角项氏所钤八印相同，笔法俱宗马（远）、夏（圭），而每图俱作二人一童子，格局相类。进而推知此无款《右军书扇图》轴应是仇英为项元汴所作四大幅之一，至今犹为定论。</p>',
    slides: [
      {
        url: gallery['sight-13756-1.jpg'],
        points: [
          {
            x: 1768,
            y: 200,
            content: '<p>吴湖帆题跋：“明仇实父为项子京画《右军书扇图》真迹，无上神品。实父为子京画《消夏图》都四大幅。二幅藏故宫博物院，一曰《蕉荫结夏图》（载《石渠宝笈》），一曰《桐阴清话图》（载《宝笈三编》）。余皆寓目，宽高与此尺寸悉同。《蕉荫结夏图》款曰‘仇英戏写’。《桐阴清话图》亦无款识（有‘十洲仇英’数字，系后添），与此亦同。四角项氏所钤八印亦同。笔法俱宗马、夏，而每图俱作二人一童子，格局相类，可知为一时作无疑。其另一图，据传在吴与庞氏，惜未见也。是幅向藏内江张氏，今归四明尔卿林先生先生秘籍。丙子（1936）夏六月出示属题，乡后学吴湖帆鉴定并识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-19336': {
    caption: '明 钱谷 溪山深秀图卷',
    thumbnail: gallery['sight-19336-0.jpg'],
    description: '<p>钱谷是吴门画派的重要画家，吴湖帆对其评价颇高，认为他是文征明最出色的弟子。在此图的题跋中，吴湖帆通过笔法的分析，指出钱谷宗法沈周、文征明之外，还上追元人画法，格局阔达，迥异于同侪。</p>',
    slides: [
      {
        url: gallery['sight-19336-1.jpg'],
        points: [
          {
            x: 2045,
            y: 80,
            content: '<p>吴湖帆题跋：“钱磬室校录善本秘籍，又藏书万卷，复工画山水，为文门弟子之冠。此卷为王元美作《溪山深秀图》，自谓平生能事尽此矣。况有元美题记，益臻故宝。余得藏之，为乡先贤手泽增光不少，如此袖珍长卷，弥益宝贵。甲戌（1934）二月，吴湖帆识。”</p>'
          },
          {
            x: 844,
            y: 463,
            content: '<p>吴湖帆题跋：“叔宝笔法虽不离乎石田、衡山，沉着浑雄颇有王孟端气味，可知其得力于元贤处亦甚深。同时若陆叔平、陈道复、居士贞、文承德辈咸以峭劲胜人，独叔宝以圆笔直下，继轨沈文，上追仲圭，规模亦最大，况此卷自诩，足见流露得意也，不独王元美得之而倾倒若此。梅景书屋又识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-19800': {
    caption: '明 董其昌 画禅室小景图册',
    thumbnail: gallery['sight-19800-0.jpg'],
    description: '<p>吴湖帆一生推崇董其昌的画风及画学思想，反复大量地观临，对董画的理解与认识极为精确。此跋指出该册为董其昌原装，亦系目前传世董氏作品中仅见。</p>',
    slides: [
      {
        url: gallery['sight-19800-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-19800-2.jpg'],
        points: []
      },
      {
        url: gallery['sight-19800-4.jpg'],
        points: [
          {
            x: 1752,
            y: 218,
            content: '<p>吴湖帆题跋：“思翁亲笔题签曰‘画禅室小景’四幅，盖随笔自赏之作也。押角俱有‘董氏家藏’小印，犹是明代初装，更可宝爱。董画中无上精品也。己巳（1929）三月收入余宝董室中。丑簃题。”</p>'
          }
        ]
      }
    ]
  },
  'sight-20015': {
    caption: '清 王翚 仿关仝溪山晴霭图卷',
    thumbnail: gallery['sight-20015-0.jpg'],
    description: '<p>四王吴恽是清代画坛的主流画派，其作品吴湖帆鉴藏特多，对他们的绘画风格也格外熟悉，多次在题跋中评论考据。此卷后即有吴氏对王翚作品风格及水平的精彩评论。</p>',
    slides: [
      {
        url: gallery['sight-20015-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 1429,
            y: 84,
            content: '<p>吴湖帆题跋：“余二十年来所见石谷画卷约四十余本，而精细之作有十七八本，惟以此卷《仿关仝溪山晴霭图》为第一。按石谷在四十岁左右，经烟客指示临摹宋元名迹后艺乃大成，故石谷画以四十至五十岁为最精，而摹古为尤工，且石谷长于宋画而不尚摹元，盖石谷之功力胜于神韵，设色胜于水墨。此卷为四十七岁摹关仝笔法，不独为石谷生平第一合作，而明清以来无第二人能为之。就余所见石谷仿宋人笔，以关仝、范宽为最擅长，亦最尠见，仅于册中偶然寓目一、二，若长卷、巨轴固未之获见也。此本在二十年前曾见之，心目不忘者纍岁，今复获之，洵晏元献词曰‘似曾相识燕归来’是也。戊寅中秋，质之孙邦瑞兄以为然否？吴湖帆识于梅景书屋。”</p>'
          }
        ]
      }
    ]
  },
  'sight-20016': {
    caption: '清 王翚 仿巨然夏山烟雨图卷',
    thumbnail: gallery['sight-20016-0.jpg'],
    description: '<p>康熙十五年（1676）</p><p>纸本 水墨</p><p>此图卷与《仿关仝溪山晴霭图》卷藏于一匣，为吴氏“仿五代关仝、巨然晴雨双卷之一”，作于1676年，作者时年四十五岁。</p><p>本卷中吴湖帆对王翚的画风分为五个时期，“故石谷（王翚）画当以四十至五十为极诣。五十至六十自具面目。六十至七十渐落俗套，每失韵致。七十至八十有衰颓气。八十以外又复变化入神，用笔如万岁枯藤，苍辣兼具，有空前绝后之妙。后人之诋諆石谷者，盖多见其六十以后八十以前作也。”可以看到，基于梳理风格演变作为比较判断的依据，是吴氏鉴研古书画过程中运用较多的重要手段。</p>',
    slides: [
      {
        url: gallery['sight-20016-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 1572,
            y: 89,
            content: '<p>吴湖帆题跋：“石古子年四十左右，在娄东王奉常家临摹宋元名迹，艺乃大成。间为太常代笔，亲受指点，益臻神化，故石谷画当以四十至五十为极诣，五十至六十自具面目，六十至七十渐落俗套、每失韵致，七十至八十有衰颓气，八十以外又复变化。入神用笔，如万岁枯藤，苍辣兼具，有空前绝后之妙。后人之诋諆石谷者，盖多见其六十以后八十以前作也。此卷康熙丙辰正四十五岁，临古而能脱古之作，故格度神韵无不妙到毫颠，所仿巨然大略与海野图相似，乃散人心神交会而致，与寻常意为者不可同语也。戊寅（1938）中秋与孙邦瑞兄弟同获寓目，互赏不置，吴湖帆并识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-31307': {
    caption: '清 王翚 早年山水图轴',
    thumbnail: gallery['sight-31307-0.jpg'],
    description: '<p>纸本 设色</p><p>王翚三十岁前的作品传世不多，此图与其癸巳（1653）二十二岁的《仿巨然山水图》轴（上海博物馆藏）相较，山水结构更趋规范，无疑系已受老二王亲炙之后的作品。约为二十七八岁作品，与其三十一岁（1662）所作《溪山雨意图》轴（美国大都会博物馆藏）相先后。</p><p>从跋文可知，吴湖帆根据“象文”印及王翚书法风格等判断，此图当为王翚三十岁以前所作。可见吴氏的鉴定是基于对石谷一生画风的精辟入里的见解，至今依然为研鉴者所继承。</p>',
    slides: [
      {
        url: gallery['sight-31307-1.jpg'],
        points: [
          {
            x: 3264,
            y: 456,
            content: '<p>吴湖帆题跋：“王石谷早年学白石翁山水真迹。石谷子初名象文，后易名翚。曾在故宫博物院获观其弱冠时画小册署名‘象文’，其时尚未以翚名也。书法初学米襄阳，此帧款式犹不脱米法而已，易名翚，印中仍存‘象文’，可证为初易名时之作。验其笔法款书，当在三十以前无疑。季迁老弟携观共研，因为诠释，俾为考证石谷画者之助。吴湖帆，甲申（1944）八月。”</p>'
          }
        ]
      }
    ]
  },
  'sight-26743': {
    caption: '明 仇英 仿古人物图册',
    thumbnail: gallery['sight-26743-0.jpg'],
    description: '<p>绢本 设色</p><p>仇英（？-约1552），字实父，号十洲，江苏太仓人，寓居苏州。</p><p>此图册原藏于李拔可家，原有二十开，其中五开于1932年毁于战火，今存十五开。吴湖帆指出此册的原稿尚有存者，保存在故宫藏《宋元人集》册中。同时，故宫藏仇英为项元汴《临宋元画册》六开，亦无署款钤印，所用绢与此图册相似。通过对图册绢色、用笔习性等综合比对，吴湖帆最终得出此图册当是仇英为项元汴所临真迹的可信结论。</p>',
    slides: [
      {
        url: gallery['sight-26743-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-2.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-3.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-4.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-5.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-6.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-7.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-8.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-9.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-10.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-11.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-12.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-13.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-14.jpg'],
        points: []
      },
      {
        url: gallery['sight-26743-15.jpg'],
        points: []
      }
    ]
  },
  'sight-31612': {
    caption: '明 李流芳 山水图册',
    thumbnail: gallery['sight-31612-0.jpg'],
    description: '<p>纸本 设色</p><p>李流芳（1575-1629），字长蘅，号檀园。安徽歙县人，侨居嘉定（今属上海市）</p><p>本图册是吴湖帆接受孙邦瑞馈赠的王武《花卉册》之后，作为回报而题赠的。孙邦瑞（1903-1972）是海上实业家、古书画藏家孙煜峰（1901-1967）的胞弟，江苏江阴人。孙邦瑞酷爱收藏，与吴湖帆有通家之谊，其藏品多由吴氏鉴定、题跋。题识中，吴湖帆特别提及此册以极少见的宋纸本画成，可见其鉴赏之精细。</p>',
    slides: [
      {
        url: gallery['sight-31612-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-2.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-3.jpg'],
        points: [
          {
            x: 840,
            y: 95,
            content: '<p>吴湖帆题跋：“此王渔洋所藏李檀园画册，八桢，宋纸本，沈绎堂、汪钝翁等题辞，皆一时名贤，荟萃一集。原有屈翁山一题，丁丑（1937）乱离中遗去。是册向藏张大千处，近岁始归敝笈，屈题已不存矣。顷邦瑞兄以王忘庵在尹山垄次所画册始贻，盖陡屺之思，白云在望，余与忘庵同感。因检此册奉赏，未足报嘉惠于万一也。庚辰（1940）岁暮，倩庵吴湖帆漫识。”</p>'
          }
        ]
      },
      {
        url: gallery['sight-31612-4.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-5.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-6.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-7.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-8.jpg'],
        points: []
      },
      {
        url: gallery['sight-31612-9.jpg'],
        points: []
      }
    ]
  },
  'sight-31924': {
    caption: '元 佚名 百尺梧桐图卷',
    thumbnail: gallery['sight-31924-0.jpg'],
    description: '<p>图卷首题署“吴兴赵孟頫”和 “赵氏子昂 ”朱文方印皆系后添。图绘文人园居闲适之景。庭院梧桐枝叶茂盛，古趣盎然。据谢稚柳考察，此图是比赵孟頫《秋郊饮马图》更为早期的作品。傅熹年撰写《元人绘〈百尺梧桐轩图〉研究》，指出此图所绘是张士信园居的情景。</p><p>曾经明人吴廷（用卿）、清人梁清标和近人周怀民收藏。吴湖帆于1952年应收藏家周氏之邀为其题跋。</p>',
    slides: [
      {
        url: gallery['sight-31924-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 1143,
            y: 120,
            content: '<p>吴湖帆题跋：“松雪花真似缓带轻裘，玉簪琼珮，风华富丽。故国王孙自具潇洒丰度，宋王晋卿无此婀娜，明仇十洲逊其蕴藉，洵画史中全才也。兹百尺梧桐图卷正中岁经营之作，图中主人不知谁何，元贤七题俱未及，其姓氏待考。独王叔明款识用谨题，则足证松雪画为真迹无疑。义一字之珍余可不赘。怀氏道兄见示，质之以为何如。壬辰大雪吴湖帆观识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-34474': {
    caption: '明 陈洪绶 花鸟草虫图卷',
    thumbnail: gallery['sight-34474-0.jpg'],
    description: '<p>绢本 设色</p><p>陈洪绶（1598-1652），字章侯，号老莲。浙江诸暨人。</p><p>吴湖帆题于本幅末尾的第一段跋语，系为原收藏者黄仲明所作的鉴定。黄氏当时是商务印书馆襄理，自开印刷厂，与吴湖帆等海上古书画收藏家交往甚密。吴湖帆在第二次题跋中提到，适逢张大千自四川来沪，他们一同欣赏名画的情景。</p>',
    slides: [
      {
        url: gallery['sight-34474-1.jpg'],
        zoomLevel: 5,
        points: [
          {
            x: 543,
            y: 107,
            content: '<p>吴湖帆题跋：“陈悔迟真迹。后学吴湖帆鉴定。”“前日仲明丈携示老莲此卷，适大千自蜀中来，相与共赏，叹观止矣，倩庵。”</p>'
          }
        ]
      }
    ]
  },
  'sight-34476': {
    caption: '明 祝允明 草书李白五言古诗卷',
    thumbnail: gallery['sight-34476-0.jpg'],
    description: '<p>纸本</p><p>祝允明（1460-1526），字希哲，号枝山，长洲（今江苏苏州）人。</p><p>卷后有吴湖帆题跋 “甲午（1954）消寒，与王文恪《手书诗》卷同获观数青草堂，吴倩。”并钤有“湖帆鉴赏”印章。“数青草堂”是钱镜塘的斋名，可知此卷当是吴湖帆为钱镜塘进行品鉴的藏品。时已成为海上画坛盟主的吴湖帆对于比他小十多岁的钱镜塘颇有提携之恩。通过与吴湖帆的交往，钱氏提高了鉴定眼光，二人被誉为海上“鉴定双璧”。</p>',
    slides: [
      {
        url: gallery['sight-34476-1.jpg'],
        points: [
          {
            x: 78,
            y: 234,
            content: '<p>吴湖帆题跋： “甲午（1954）消寒，与王文恪《手书诗》卷同获观数青草堂，吴倩。”</p>'
          }
        ]
      }
    ]
  },
  'sight-35365': {
    caption: '明 董其昌 行书苏轼重九词轴',
    thumbnail: gallery['sight-35365-0.jpg'],
    description: '<p>天启元年（1621）</p><p>纸本</p><p>董其昌（1555-1636），字玄宰，号香光居士，华亭（今上海松江）人。</p><p>此卷为董其昌辛酉年（1621）所书苏东坡《西江月》词一首：“点点楼前细雨，重重江外平湖。当年戏马会东徐，今日凄凉南浦。莫恨黄花未吐，且教红粉相扶。酒阑不必看茱萸，俯仰人间今古”。吴湖帆题“万历辛酉，公五十七岁”有误，应为天启辛酉董其昌年六十七岁时作。吴氏鉴定指出此轴形制与本展中《画禅室小景图》册皆属明代万历原装，故十分珍视。</p>',
    slides: [
      {
        url: gallery['sight-35365-1.jpg'],
        points: [
          {
            x: 1340,
            y: 300,
            content: '<p>吴湖帆题跋：“明董文敏为雷宸甫书东坡词真迹。万历辛酉，公五十七岁。此帧犹是万历当日原装，更可宝贵。余蓄董氏书画十数事，尚存原装者，祇戊午（1918）画《画禅室小册》与此轴耳。潢池如出一手，三百年后吴湖帆珍爱逾恒。丙戌（1946）长夏，梅景书屋。”</p>'
          }
        ]
      }
    ]
  },
  'sight-39393': {
    caption: '南宋 佚名 樱桃黄鹂图页',
    thumbnail: gallery['sight-39393-0.jpg'],
    description: '<p>本图作者不详，题者系南宋宁宗杨皇后，吴湖帆在画上有长篇题跋考证其人名号之实。</p>',
    slides: [
      {
        url: gallery['sight-39393-1.jpg'],
        points: [
          {
            x: 1545,
            y: 45,
            content: '<p>吴湖帆题跋：“宋宁宗后杨姓画《樱桃黄鹂图》真迹。是帧乃杨皇后画赠其兄永阳郡王杨次山者。印章文曰：‘癸酉年春杨姓之章’八字。按，癸酉为南宋宁宗嘉定六年（1213）。”“按，杨姓之书题，有《故宫所藏书画集》第十一期第一品马麐画《层叠冰绡图》题眉四字及诗云：‘浑如冷蝶宿花房，抱拥檀心忆旧香。开到寒梢尤可爱，此般必是汉宫妆。’画后注杨姓，误作杨娃，盖娃为姓之妹，世称‘杨妹子’其人焉。又，故宫藏马麐画《春花册》十帧，其每帧题眉亦姓，书钤印曰‘坤宁睿笔’。以上二题，皆嘉定丙子年（1216）书，距此册后三年，吴湖帆鉴识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-39480': {
    caption: '明 唐寅 款鹤图卷',
    thumbnail: gallery['sight-39480-0.jpg'],
    description: '<p>纸本 设色</p><p>吴湖帆对此图进行了包括上款、名号、年份、笔法等综合鉴定，并以唐寅《南州借宿图》和本展沈周《苔石图》轴作为比对的参照物，最终得出“此卷为居士三十七八岁作可证也”的可信结论。可见，在实际鉴研过程中，吴湖帆注重相关材料的综合比对，进而为其结论提供确信依据，并不仅仅依靠主观感受与经验。</p>',
    slides: [
      {
        url: gallery['sight-39480-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 1777,
            y: 151,
            content: '<p>吴湖帆题跋：“款鹤为王酉室吏部之父，曾见祝枝山书《款鹤先生墓志》墨迹册于闽友处，款鹤卒年一时记忆不清矣。按石田翁卒于弘治己巳（1509），年八十三，是岁六如居士四十岁。此卷画法与六如之《南州借宿图》相同，其为一时作无疑义。又石田翁诗题，与吾家《苔石图》诗题亦似一时手笔。《苔石图》作于丙寅（1506），石翁年八十，则此卷为居士三十七八岁作可证也。六如画绢素多出楮本什百倍，其横卷更尠见。宜吾乡谢氏、溧阳狄氏皆以环宝视之，今归吾友邦瑞孙先生，物聚所好，应庆是卷得所矣。甲申（1944）二月春分节，吴湖帆重观题记。”</p>'
          },
          {
            x: 748,
            y: 185,
            content: '<p>“去年余获购六如《坐爱枫林》绢本小幅，亦用小斧劈皴，以笔尖正锋而不施侧笔，虽云师法李希古，十六如自立法门，与此卷及《南州图》皆一时作也。六如廿九岁中南京解元，自后十年为书画最精进时期。至宸濠放归后便入颓唐，无此精聚神会矣。邦瑞得六如画《款鹤图》，如米襄阳得右军《王略帖》，快不可铭，携示共赏，又识卷末。倩庵吴湖帆。”</p>'
          }
        ]
      }
    ]
  },
  'sight-41705': {
    caption: '明 董其昌 秋兴八景图册',
    thumbnail: gallery['sight-41705-0.jpg'],
    description: '<p>万历四十八年（1620）</p><p>纸本 设色</p><p>刘靖基捐赠</p><p>此册作于庚申年（1620），作者时年六十六岁。</p><p>此册曾被庞元济收藏。庞元济（1864-1949），字莱臣，号虚斋，浙江南浔人。为海上首屈一指的藏家，其藏品丰富程度几乎无人能出其右。此册吴湖帆寓目数次，给予很高评价，如在吴氏题董其昌《画禅室小景图》册指出，“七月初六日获见《秋兴八景》册于庞氏（庞莱臣），为大册中至精者”。</p>',
    slides: [
      {
        url: gallery['sight-41705-1.jpg'],
        points: []
      }
    ]
  },
  'sight-45513': {
    caption: '明 唐寅 骑驴思归图轴',
    thumbnail: gallery['sight-45513-0.jpg'],
    description: '<p>绢本 设色</p><p>唐寅（1470-1523），字伯虎、子畏，号六如居士等。</p><p>吴氏崇尚南宗，推崇元代文人画风。但吴门画派中唐寅的画风亦给他很大的影响，吴氏评论唐寅画为“以南宗精韵表北宗骨干”，而其自己的某些作品中也有以北宗技法展现南宗气韵的特色，可谓异曲同工。</p>',
    slides: [
      {
        url: gallery['sight-45513-1.jpg'],
        points: [
          {
            x: 87,
            y: 1527,
            content: '<p>吴湖帆题跋：“六如居士画，昔人论曰：远攻李唐，足任偏师，而不知其疏宕处得力于夏禹玉甚深，又能以南宗精韵表北宗骨干，是所谓运百炼钢若绕指柔，发千古画苑奇格，不独与沈文角胜一时也。此自写诗意图，前岁以宋椠河上本《道德经》易于密韵搂。据王栩缘丈考为归自豫章时作，信有征也。余所见六如画精华所萃，应推是图为甲观矣。丙子（1936）闰三月重装，乡后学吴湖帆识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-45529': {
    caption: '元 吴镇 渔父图卷',
    thumbnail: gallery['sight-45529-0.jpg'],
    description: '<p>至正五年（1345）</p><p>纸本 水墨</p><p>吴镇（1280-1354），字仲圭，号梅花道人，浙江嘉兴人，“元四家”之一。</p><p>吴湖帆获藏此图，如获至宝，屡作赏鉴、考订，定为“吴氏四宝”之一。当时海上大藏家庞莱臣也获购一件吴镇《渔父图》卷，两卷极为相似。吴湖帆曾数次得以观摩庞本，经过认真鉴考比对，认为庞本系伪，并撰专文辨析，其断伪依据剖析甚详。比如《丑簃日记》1933年二月写道：“校仲圭《渔父图》庞氏藏《式古堂》著录本。款字梅花道人‘梅’‘道’二字书不成字。‘十余年矣’之‘余’字书误作‘余’。‘流光易得’之‘易’书似‘曷’字。‘风揽长江’之‘揽’字手旁误不成字。‘弄晓霞’之‘霞’下半似‘霜’非‘霜’、似‘霞’非‘霞’。‘酒缾侧’之‘侧’字似‘倒’字而缺笔。‘只向湖中’之‘向’字不成字。”</p><p>吴氏的鉴定意见时获张大千等人认可。</p>',
    slides: [
      {
        url: gallery['sight-45529-1.jpg'],
        zoomLevel: 10,
        points: []
      }
    ]
  },
  'sight-45531': {
    caption: '北宋 米芾 行书多景楼诗册',
    thumbnail: gallery['sight-45531-0.jpg'],
    description: '<p>《多景楼诗册》为梅景书屋重宝，吴湖帆对之珍爱逾常，钻研极深，先后多次题跋，对此册创作年代、流传经过、艺术成就皆有详尽的考证论述。</p>',
    slides: [
      {
        url: gallery['sight-45531-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-45531-2.jpg'],
        points: [
          {
            x: 1629,
            y: 235,
            content: '<p>吴湖帆题跋：“多景楼为天下有数名胜，米襄阳此书为天下有数名迹。在北宋时，蔡元度席上何伯通以‘三绝’誉之，阅今八百余载，完美如故，得而藏之，岂非神灵默护，应有吉祥云覆我处也。乙酉（1945）七月初旬吴湖帆识于梅影书屋”。</p><p>“此册自宋以来，所藏历历皆可考见。北宋时，已邀赏于蔡氏。南宋时，归秦桧、秦熺、秦埙者，凡三世。明初，为黔宁王子沐素轩昂所得，传至其孙廷章璘。册中‘黔宁王子孙永保之’印、‘征南将军图书’印、‘公余清玩’印，‘沐璘廷章’印等，皆沐氏藏印也。明季而归曹倦圃侍郎，清初而归梁蕉林相国，而朝鲜安岐籍入清内府，得邀高宗睿赏，分赐成亲王诒晋斋而勒石入帖。清季为常熟邵息斋太史所得，迄今数十年，海宇方靖，相庆和平告成，遂为我有，疏记志快，倩庵又识。”</p><p>“据何太傅题于崇宁元年壬午，按襄阳生于皇祐三年辛卯，殁于大观元年丁亥，年五十七，则壬午年当五十二，米氏犹健在也。可知当日声誉之隆，况距今八百四十四年之后，宝贵当如何耶。民国卅四年乙酉湖帆得此，时年五十二喜记。”</p>'
          }
        ]
      }
    ]
  },
  'sight-45532': {
    caption: '明 蓝瑛 江亭诗思图扇',
    thumbnail: gallery['sight-45532-0.jpg'],
    description: '<p>顺治十四年（1657）</p><p>金笺 设色</p><p>蓝瑛（1585-1664后），字田叔，钱塘（今浙江杭州）人。本图作于顺治十四年（1657），作者时年七十三岁。</p><p>吴湖帆时代，史料缺乏，蓝瑛生卒年份俱不详。而吴湖帆据此扇所署年份岁数，推知蓝瑛生于万历十三年（1585），弥补了画史之缺。</p><p>从相关作品之比较，画家生卒、名号、斋名、上款人及相关背景人物交游等方面之考证，乃至用印、装潢与形制等细节观察，无不表明对吴湖帆而言，书画鉴定是一门目鉴与考证相结合的学问。诚如本扇中吴氏题语中所言，“书画之足证如此，不独以玩赏为雅事云”。</p>',
    slides: [
      {
        url: gallery['sight-45532-1.jpg'],
        points: [
          {
            x: 1864,
            y: 50,
            content: '<p>吴湖帆题跋释文：“田叔生年画籍俱不详，今得此箑，作于顺治十四年丁酉，年七十三，推其生在万历十三年乙酉也。书画之足证如此，不独以玩赏为雅事云。是箑用笔如大痴芝兰室图。”</p>'
          }
        ]
      }
    ]
  },
  'sight-45532a': {
    caption: '明 唐寅 携琴访友图扇',
    thumbnail: gallery['sight-45532a-0.jpg'],
    description: '<p>金笺 设色</p><p>吴湖帆的鉴定注重作品的笔法、印记和款识的审定。从跋文可知，吴湖帆据“笔法款识”，初步判断此图是唐寅“当在五十岁以前精力最弥漫时所作”，再据唐氏自钤“学圃堂”</p><p>一印作为断代年份之旁证，称“此印亦四十以后所用”。可见，印鉴在书画鉴定与研究中所起到的辅助作用，吴氏皆予以相当重视。</p>',
    slides: [
      {
        url: gallery['sight-45532a-1.jpg'],
        points: [
          {
            x: 1832,
            y: 81,
            content: '<p>吴湖帆题跋释文：“唐六如携琴访友图便箑无上精品。余好六如画，所集便箑中人物山水最精者只二三品，此起一也。以画品论，浑成、老练、苍秀兼具，审其笔法与款识，当在五十岁以前精力最弥满时所作。学圃堂一印亦四十以后所用，曾获兰亭修褉图小卷，用笔用墨，人物勾勒，树石皴法乃一时作也。乙丑夏日所得。湖帆记珍。同时所收文衡山春有图便面亦至精品。”</p>'
          }
        ]
      }
    ]
  },
  'sight-45534': {
    caption: '南宋 景定二年刊梅花喜神谱',
    thumbnail: gallery['sight-45534-0.jpg'],
    description: '<p>此谱为吴湖帆夫人潘静淑陪嫁宋刻孤本，极为珍罕。从题跋可知，吴湖帆对其源流加以考证，认定此册为宋代的祖刻本。</p>',
    slides: [
      {
        url: gallery['sight-45534-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-45534-2.jpg'],
        points: [
          {
            x: 78,
            y: 342,
            content: '<p>吴湖帆题跋：“知不足斋丛书所刻此谱易题眉于书旁，卷尾摹刻绍兴旌中裒节之家印，可证此册为鲍氏祖本，更证书经翻镌不复旧观之失。丙寅中秋吴湖帆识”</p>'
          }
        ]
      }
    ]
  },
  'sight-45537': {
    caption: '明 徐渭 草书春雨帖七古二章卷',
    thumbnail: gallery['sight-45537-0.jpg'],
    description: '<p>吴湖帆收藏的兴趣多集中于正统和主流的书画家作品，但对于徐渭的作品则大为欣赏，认为其虽然狂放，却始终不脱离二王书法的法度。</p>',
    slides: [
      {
        url: gallery['sight-45537-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 2283,
            y: 67,
            content: '<p>吴湖帆题跋：“天池之书，自米法上溯，几欲夺旭、素之席，所谓天马行空，不可羁勒矣。学之者往往狂诞过甚，遂入邪魔，如板桥一流。天池则任狂任放，总不脱二王藩笼即其好处，故能横绝千古而不磨者也。此卷十年前为徐伟士姊丈所赠，前后凡七古二章，款书‘隆庆春之望’，当是隆庆改元之初，可证其醉后信笔脱纪年月耳。戴文节、吴笏庵、许信臣三跋尤见完整，可宝。曩岁倚《贺新郎》词题之，癸酉（1933）春三月补书。”</p>'
          },
          {
            x: 1505,
            y: 85,
            content: '<p>“醉态诗中省。想当初、信手挥毫，墨华飞去。尽尔虺蛇惊座笔，对此也须目瞪。诧狂比颠张尤横。毕竟书生多胆气，仗锦心辣手豪情逞。天斗大，我光顶。青藤诗有秃头光顶之句。破头血迸菭花冷。且莫问、命误文章，文章误命。才子从来多无褔，枉说风流孽证。往往借、美人吊影。梦里巴山听夜雨，忆马嵬、痛哭华清幸。谁味得，此中境。吴湖帆珍藏并题。”</p>'
          }
        ]
      }
    ]
  },
  'sight-45539': {
    caption: '元 张中 芙蓉鸳鸯图轴',
    thumbnail: gallery['sight-45539-0.jpg'],
    description: '<p>此图为1935年吴湖帆所得清宫旧藏，极为珍贵，吴氏通过对其上印章的考据，梳理了这幅画的流传经历，指出此画曾经明代沈周伯父与文征明外曾孙收藏。</p>',
    slides: [
      {
        url: gallery['sight-45539-1.jpg'],
        points: [
          {
            x: 1042,
            y: 86,
            content: '<p>吴湖帆题跋：“此图右下角有‘贞吉印’，乃石田翁之父沈贞吉也。‘贞吉印’之上‘薛益之印’，意即文衡山之外曾孙薛明益虞卿也。虞卿工小楷，宗文氏法，万历、崇祯间吾吴书家。此图上自宣德、景泰，下至明末，百数十年间，俱藏吾吴，越今又三百年而复归余有，可谓神灵所佑矣。”</p>'
          }
        ]
      }
    ]
  },
  'sight-46358': {
    caption: '清 吴历 寿许青屿山水图轴',
    thumbnail: gallery['sight-46358-0.jpg'],
    description: '<p>康熙十一年（1672）</p><p>纸本 设色</p><p>吴历 (1632-1718)，字渔山，号墨井道人，江苏常熟人。此图系四十一岁的吴历为贺友人许之渐六十岁寿辰而作。</p><p>吴湖帆关注江南一带尤其沪上各大藏家的收藏，对庞莱臣、钱镜塘、冯超然等友人的诸多藏品不仅如数家珍，且多有题鉴。此图曾为清代顾文彬旧藏，《过云楼书画记》卷六著录，后为钱镜塘所得。1949年春日，吴氏在观此画后，将自己的鉴定结论，以题签形式书于画上，不仅定为“真迹”，且称之为“青绿山水神品”</p>',
    slides: [
      {
        url: gallery['sight-46358-1.jpg'],
        points: []
      }
    ]
  },
  'sight-50327': {
    caption: '南宋 佚名 晚景图轴',
    thumbnail: gallery['sight-50327-0.jpg'],
    description: '<p>绢本 水墨</p><p>图绘重岩叠嶂，意境高旷，布局清丽紧凑，用笔简练明确，俨然自北宋范宽一路出，更显出通透变幻的南宋山水气派。</p><p>1950年，吴湖帆为收藏家钱镜塘题跋，追溯了此图于明清以来的流传经历：曾经明严嵩，清梁清标、谢淞洲、毕泷、刘恕、葛金烺收藏。著录于《佩文斋书画谱》卷九十八、《珊瑚网》卷四十七、《爱日吟庐书画录》卷一。</p>',
    slides: [
      {
        url: gallery['sight-50327-1.jpg'],
        points: [
          {
            x: 171,
            y: 1866,
            content: '<p>吴湖帆题跋：“明严分宜籍没时，文休承适为南昌教谕，任其役有点收严氏所藏书画目录，范宽《晚景图》是其一焉。《佩文斋》及汪氏《珊瑚网》所录即据文氏目录。录入是图后，入梁蕉林、谢林邨、毕竹屿、刘蓉峰诸家收藏。今据毕竹屿晚年手定本自书于聚头扇上。广堪斋藏画目凡五代宋元明名画七十九事，经四十年苦心所积，不啻神交师友。元章所谓声色之美不能夺也。是图近为吾友钱镜塘君所得，见眎属疏证之。庚寅秋吴湖帆观识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-51068': {
    caption: '明 沈周 苔石图轴',
    thumbnail: gallery['sight-51068-0.jpg'],
    description: '<p>正德元年（1506）</p><p>纸本 水墨</p><p>此图作于正德元年，作者时年八十岁。</p><p>兼具传统文人与现代学者双重特质的吴湖帆，与稍晚的张珩等鉴定家一样，业已展示出兼融传统画学与现代科学研究方法的趋势，在书画鉴定方面，皆重视相关作品的比对和考证。</p><p>1944年吴湖帆获藏此图之际，根据家藏另一件沈周正德二年（1507）《牡丹花》轴（南京博物院）推断，图中上款“复端”即为澄江缪复端。更为重要的是，吴湖帆将《苔石图》轴中沈周八十岁书风作为参照物，进而对沈周题唐寅的无年份作品《款鹤图》卷进行了真伪鉴定与年份考证。</p>',
    slides: [
      {
        url: gallery['sight-51068-1.jpg'],
        points: [
          {
            x: 123,
            y: 807,
            content: '<p>吴湖帆题跋：“五百年来翰墨遗，重牋余仰费清辞。兴披老到梅花笔，警摘门当车马诗。咏发画先真意得，祖缘孙袭旧交知。石翁八十神犹壮，‘苔石’名图析赏宜。甲申（1944）秋日喜获此图，石翁老笔纷披，精彩奕奕，洵属神品，为依原题韵书贉。吴湖帆珍藏。”</p>'
          },
          {
            x: 1845,
            y: 1593,
            content: '<p>吴湖帆题跋：““近获石田翁为澄江缪复端画《牡丹花》轴，作于正德二年（1507），有《惜余春》、《临江仙》二词，当时唱和者尚有薛尧卿，此图为复端即其人焉。戊子（1948）九月湖帆又记。””</p>'
          }
        ]
      }
    ]
  },
  'sight-51117': {
    caption: '清 范廷镇 山水图册',
    thumbnail: gallery['sight-51117-0.jpg'],
    description: '<p>纸本 设色</p><p>晚清以降，顾文彬、何绍基、褚德彝等均视此作为恽寿平、王翚、范廷镇三人山水合册。《中国古代书画图目》将其定为范氏作品。</p><p>二十世纪三十年代，吴湖帆在日记中指出：“范廷镇，字趾安，画法花卉，与南田能乱真。各书俱不载，以年代笔法论，当是南田弟子。”吴湖帆眼光如炬，著名的“代笔说”亦出自其口。例如，文彭、文嘉、文伯仁等为文征明代笔，赵左、沈士充、吴易等为董其昌代笔，薛宣为王鉴代笔，王翚、王原祁等为王时敏代笔。</p>',
    slides: [
      {
        url: gallery['sight-51117-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-2.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-3.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-4.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-5.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-6.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-7.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-8.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-9.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-10.jpg'],
        points: []
      },
      {
        url: gallery['sight-51117-11.jpg'],
        points: []
      }
    ]
  },
  'sight-59917': {
    caption: '宋拓 梁萧敷敬妃墓志铭合册',
    thumbnail: gallery['sight-59917-0.jpg'],
    description: '<p>此册为吴氏梅景书屋至宝，号称“墨皇”。吴湖帆对其钻研精深，逐行校理，又对册中印鉴、装裱等详加审订，曾多次题跋，据其有关历代双志原石、原拓记载相关考证分析，该本定为宋拓孤本言之有理。</p>',
    slides: [
      {
        url: gallery['sight-59917-1.jpg'],
        points: []
      },
      {
        url: gallery['sight-59917-2.jpg'],
        points: [
          {
            x: 1090,
            y: 288,
            content: '<p>湖帆册前画跋：“绍兴时，《永阳王志》在清风乡民居井畔，《敬太妃志》在清风乡路旁。见宋张养正《六朝事迹类编》。宋王覆斋《覆斋碑录》收其目，未详处所。元陶九成《古刻丛抄》仅录《敬太妃志》而不着《永阳王志》，可知元时王志已亡，陶氏已无从见矣，矧越今又六百载，更可贵何如。梁代文物，祇武帝书《异趣帖》，刻入《戏鸿堂》、《三希堂》二帖中，今亦不知亡存。又，范氏天一阁所藏之宋拓《旧馆坛碑》，仅顾湘舟得张叔未所寄双钩本，摩勒一石，载碑名及结衔一行，为陶弘景手书，原拓亦久湮矣。静淑去世已十年，五载以来，皆抱真继主掌理，并识于迢迢阁。湖帆。”</p>'
          }
        ]
      },
      {
        url: gallery['sight-59917-3.jpg'],
        points: [
          {
            x: 951,
            y: 1260,
            content: '<p>吴湖帆题跋：“南朝有志墓之禁，此奉敕所撰，乃特例也。王志渊穆，妃志峭劲，况为宋拓孤本，洵墨皇也。双修阁中，可无愧色。癸酉（1933）春，吴湖帆题，潘静淑书。”</p><p>“原石《永阳王志》，凡三十行，行三十六字；《敬太妃志》，凡二十六行，行三十一字。王志第三行‘皇’字低一格，三十五字；石高六十公分，阔五十八公分。妃志高阔均五十公分。今将逐行石文校理，所有方履籛、陆增祥未辨、误处，一一订正；后附摄影整本，湖帆又志。”</p>'
          }
        ]
      },
      {
        url: gallery['sight-59917-4.jpg'],
        points: [
          {
            x: 3130,
            y: 251,
            content: '<p>吴湖帆题跋：“左下角缺有王着小印，按宋初有王着二，皆以书名，虽或由同姓名者，均无此考，亦无此巧合也。湖帆识”。</p>'
          }
        ]
      },
      {
        url: gallery['sight-59917-5.jpg'],
        points: [
          {
            x: 3868,
            y: 1542,
            content: '<p>吴湖帆题跋：“此不独宋拓，犹是明代库装。尤可宝贵，湖帆记。”</p>'
          }
        ]
      }
    ]
  },
  'sight-64330': {
    caption: '清 方薰 仿大痴山水图轴',
    thumbnail: gallery['sight-64330-0.jpg'],
    description: '<p>纸本 水墨</p><p>杨瓞绵捐赠</p><p>方薰（1736-1799），字兰士，号兰如，石门（今浙江崇德）人。擅画山水、花鸟、人物。</p><p>据《丑簃日记》载，此轴为吴湖帆于1933年赴沪上“湖社书画展览会”当场购买。从吴湖帆跋文可知，吴氏认为此图为其仅见的方薰山水画真迹，称“观此可证纤弱一种，皆非方氏真迹”。在长期探求中，吴湖帆不断将经验与心得加以总结，并将这些成果运用于实际鉴定中。</p>',
    slides: [
      {
        url: gallery['sight-64330-1.jpg'],
        points: [
          {
            x: 1728,
            y: 128,
            content: '<p>吴湖帆题跋：“奚铁生题方兰坻《仿大痴密林陡壑图》。乾嘉之际，石门方兰坻薰与钱唐奚铁生冈斋名画坛，曰：方、奚盖继‘四王吴恽’之后领袖艺苑。奚画每易获观，方画则十不一二。此图方氏真迹，又得奚氏题语，二难并合，夫岂偶然哉。癸酉（1933）四月得于沪上，吴湖帆题记于梅景书屋。”</p>'
          },
          {
            x: 136,
            y: 2164,
            content: '<p>吴湖帆题跋：“方樗庵书多花卉，山水仅见此幅，用笔沉郁，有仲圭、香光神味，远出张篁邨、钱文敏之上。观此可证纤弱一种，皆非方氏真迹。奚蒙泉题曰近大痴《陡壑密林图》，犹未能尽其长也。四月五日吴湖帆题方、奚双幅之一。”</p>'
          }
        ]
      }
    ]
  },
  'sight-64339': {
    caption: '明 董其昌 北山荷锄图轴',
    thumbnail: gallery['sight-64339-0.jpg'],
    description: '<p>绫本 水墨</p><p>董其昌的作品是吴湖帆重要的收藏对象，在鉴定上，吴湖帆亦对其作独有心得，。此图吴氏从董其昌的书迹与画风判断，定为董氏七十岁左右作品，当属的论。</p>',
    slides: [
      {
        url: gallery['sight-64339-1.jpg'],
        points: [
          {
            x: 1830,
            y: 1701,
            content: '<p>吴湖帆题跋释文：“思翁神来之笔，直逼痴迂。此图天机流畅、刚健婀娜，恐起倪黄，亦当退避，非寻常随笔可及。审其笔势，在七十岁以前所作为无疑义。庚寅（1950）夏吴湖帆鉴识。”</p>'
          }
        ]
      }
    ]
  },
  'sight-64770': {
    caption: '明 文征明 秋声赋图卷',
    thumbnail: gallery['sight-64770-0.jpg'],
    description: '<p>嘉靖二十六年（1547）</p><p>纸本 设色</p><p>此图作于1547年，作者时年七十八岁。图后为明代王守草书秋声赋，据题跋可知，此画或为文征明于嘉靖二十六年夏往访王守、王宠兄弟时为王守的自书卷补图。</p><p>吴湖帆鉴定重视笔法和相关背景资料的考证。通过对此卷引首四字笔法的比对，吴湖帆推翻了王养度的结论，认为此四字并非文征明所书，而是出自王守。此外，吴氏还对王守、王宠兄弟读书的石湖精舍和“韡韡斋”印章进行考察，推断文氏款识“寓湖上”，盖即客寓王氏兄弟的石湖精舍，进而对此图的作画地点进行了合理推论。</p>',
    slides: [
      {
        url: gallery['sight-64770-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 15766,
            y: 97,
            content: '<p>吴湖帆题跋释文：“右引首四大字亦王涵峰手书也，依笔势索之与后赋一致。辛卯秋日吴湖帆鉴定。”</p>'
          },
          {
            x: 10465,
            y: 81,
            content: '<p>吴湖帆题跋释文：“是图文氏用笔完全取法王黄鹤及松秀之能事，款识‘寓湖上’，盖即王涵峰、履吉兄弟石湖精舍也。”</p>'
          },
          {
            x: 959,
            y: 112,
            content: '<p>吴湖帆题跋释文：“石湖精舍为王涵峰守、履吉宠兄弟读书处。家有韡韡齐，余曾收履吉书小楷《三赋》册，亦钤此印可证。王氏昆弟俱受学于蔡九逵羽，书法皆习永兴，而涵峰兼涉苏、米，履吉小楷则精于大令《十三行》。此《秋声赋》盖涵峰得意书，或是夏衡翁适至精舍，涵峰又出观赏之，为之补图，乃近情理之事。王蒙泉以为引首四字为文书则误也。前岁获于沪上，辛卯（1951）秋重装，吴湖帆识。引首为王涵峰书，又记。”</p>'
          }
        ]
      }
    ]
  },
  'sight-64772': {
    caption: '明 戴进 秋林策杖图页',
    thumbnail: gallery['sight-64772-0.jpg'],
    description: '<p>纸本 水墨</p><p>戴进（1388-1462），字文进，号静庵、玉泉山人。钱塘（今浙江杭州）人。此图无作者款印。经吴湖帆考证，作者应为戴进。</p><p>此图为吴湖帆集配明初画家山水册页之一。吴湖帆对其所鉴藏的书画大多会进行一番考订，或追溯风格渊源，或爬梳流传轨迹，往往言简意赅，切中肯綮，这正是其与一般藏家的不同之处，亦是后人分外重视其藏品的原因。</p>',
    slides: [
      {
        url: gallery['sight-64772-1.jpg'],
        points: [
          {
            x: 1792,
            y: 103,
            content: '<p>吴湖帆题跋释文：“戴文进《秋林策杖图》。钱塘戴进宗法马夏，为北宋后劲。自元以来皆宗子久、叔明，凡马、夏斧劈几为凈扫，明初以来祇戴氏一人独树坛坫，仿佛北宋中鲁殿也。是图出自夏禹玉而得形神俱似者，洵名笔焉。吾友闽侯李拔可先生近获《宋元集珍册》，中有一帧斗方，绢本，款书‘夏圭’二小字，树石位置与此悉合，其此之滥觞与？湖帆又记。”</p>'
          }
        ]
      }
    ]
  },
  'life1-3310': {
    caption: '北宋 赵佶 楷书千字文卷',
    thumbnail: gallery['life1-3310-0.jpg'],
    description: '<p>崇宁三年（1104）</p><p>纸本</p><p>赵佶（1082-1135），即宋徽宗，擅书法，自创 “瘦金体”。此卷与其传世另一名迹 ——《宋人法书》第一册《欲借风霜二诗帖》用笔相同，为传世名迹。此书结体匀称，用笔轻按重收，顿转利落，具有飘逸清润之感。由卷尾年款可知，本卷为赵佶二十三岁时作品。</p><p>此卷后自清宫流散，为吴湖帆、潘静淑夫妇1924年正式移居上海后所购法书名迹之一。</p>',
    slides: [
      {
        url: gallery['life1-3310-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 224,
            y: 40,
            content: '<p>赵佶题款释文：“崇宁甲申岁（1104），宣和殿书，赐童贯。”</p>'
          }
        ]
      }
    ]
  },
  'life1-6662': {
    caption: '元 赵雍 青影红心图轴',
    thumbnail: gallery['life1-6662-0.jpg'],
    description: '<p>绢本 设色</p><p>赵雍（1289-1360后），字仲穆，吴兴（今浙江湖州）人,赵孟頫子。书画继承家学，尤精人物鞍马。图中以墨青撇出竹叶和蕙兰叶片，以汁绿点兰花瓣，绛红轻染蕊心，近没骨古法，为元人兰竹画中所罕见。图中竹干浑圆厚重如写篆籀，竹叶遒劲凝炼恰似八分，潇洒飘逸的兰叶就像行草书。再伴之以湖石，显出富有文人画趣味的书法意韵。</p><p>此图经明文征明、项元汴藏。在成为梅景书屋藏品前，一度为吴湖帆友人黄仲明所收藏。</p>',
    slides: [
      {
        url: gallery['life1-6662-1.jpg'],
        points: []
      }
    ]
  },
  'life1-8815': {
    caption: '南宋 赵构 临虞世南真草千字文卷',
    thumbnail: gallery['life1-8815-0.jpg'],
    description: '<p>绢本</p><p>赵构（1107-1187），字德基，宋高宗。工正、行、草书，少即喜揽笔作字。笔法端雅淳厚、涵泳隽秀， 盖以得力于智永为多，又尝深究本朝黄庭坚书，亦颇能得其神髓。</p><p>此卷是吴湖帆于1930年在上海购得。</p>',
    slides: [
      {
        url: gallery['life1-8815-1.jpg'],
        zoomLevel: 10,
        points: []
      }
    ]
  },
  'life1-19800': {
    caption: '明 董其昌 画禅室小景图册',
    thumbnail: gallery['life1-19800-0.jpg'],
    description: '<p>万历四十六年（1618）</p><p>纸本 水墨</p><p>有董其昌自签：“画禅室小景四幅，戊午（1618）三月。”可知作者时年六十四岁。</p><p>董其昌在绘画理论上的最大贡献，莫过于画分南北，以禅喻画。吴湖帆钤“宝董室”印于册上，实属双美。此印为其外祖父沈树镛请钱叔盖所治，不幸散佚他处，后终得完璧。今与董氏画作相映成辉。吴湖帆外祖沈氏与其本人皆以“宝董”名室，此为出处之一。</p>',
    slides: [
      {
        url: gallery['life1-19800-1.jpg'],
        points: []
      },
      {
        url: gallery['life1-19800-2.jpg'],
        points: [
          {
            x: 1709,
            y: 518,
            content: '<p>吴湖帆题跋释文：“先外祖韵初沈公收北苑《夏山图》大卷、《谿山行旅》半幅图，颜居所曰‘宝董’，倩仁和钱叔盖治小印焉。此咸丰间事，粤今七十年。北苑二画俱不为沈氏有，小印由湘之表兄贻余，时戊午十月适得思翁《戏鸿堂摹古法帖》十卷真迹，因沿‘宝董’之名名余小室。前年又获此册，乃思翁自怡物，虽仅四叶，而精妙绝伦，胜人鹅溪十丈绢也，因识‘宝董’之由。辛未（1931）三月十日又题。”</p><p>“醉舞且摇鸾凤影，浩歌莫遣鱼龙泣。此辛稼轩得意句，仿佛思翁纵笔情概。后学吴湖帆漫书。”</p>'
          }
        ]
      },
      {
        url: gallery['life1-19800-3.jpg'],
        points: []
      }
    ]
  },
  'life1-20015': {
    caption: '清 王翚 仿关仝溪山晴霭图卷',
    thumbnail: gallery['life1-20015-0.jpg'],
    description: '<p>康熙十七年（1678）</p><p>纸本 设色</p><p>王翚（1632-1717）字石谷，江苏常熟人。清初“四王”之一。本图是作者四十七岁时所作，为数月之后赴京主持《康熙南巡图》前的重要作品。</p><p>1937年抗战爆发，乱世之际，南北阻隔，尤其江浙迭遭兵乱，吴氏家族经济来源受到严重冲击，“平生心爱之品出门，几如李后主挥泪别官人，意殊不舍，情实难堪”。此番情形至1938年夏季始有好转，此卷以及本展中钱选《蹴鞠图》卷、元人《山水三段图》卷等巨迹皆为之后所购。</p>',
    slides: [
      {
        url: gallery['life1-20015-1.jpg'],
        zoomLevel: 10,
        points: []
      }
    ]
  },
  'life1-31912': {
    caption: '元 钱选 蹴鞠图卷',
    thumbnail: gallery['life1-31912-0.jpg'],
    description: '<p>纸本 设色</p><p>钱选（约1235-1299后）字舜举，号玉潭，吴兴（今浙江湖州）人。宋末元初著名画家。本图是否出自钱选手笔，尚待研究。</p><p>吴湖帆以一“彼此皆至宝”的“周四足宝敦”换得此《蹴鞠图》与元人《山水三段图》卷。据跋可知，吴氏认为钱选是宋元之间绘画风气转变的关键人物，是启发了文人画风的宗匠。收藏家的藏品最能反映他的艺术观点与品味，湖帆不遗余力地购藏钱选与元人作品，是其艺术传承文人画风的有力佐证。</p>',
    slides: [
      {
        url: gallery['life1-31912-1.jpg'],
        zoomLevel: 5,
        points: [
          {
            x: 6288,
            y: 78,
            content: '<p>吴湖帆题跋：钱舜举蹴鞠图真迹。霅川翁画元初冠冕，松雪以师礼事之。其所作人物直继道子、龙眠。此图旧藏王弇州许。湖帆秘籍。”</p>'
          },
          {
            x: 3534,
            y: 84,
            content: '<p>吴湖帆题跋：吴湖帆题跋释文：“玉潭当宋元之交以书画相尚，将宋贤刻画转啓元人潇洒法门，故如房山、松雪、子久、贞素诸家咸推之宗师。其真迹之流传迄今者盖亦仅矣。余所见《山居图》三卷及故内《秋瓜》而已，若《梨花》、《紫茄果》亦熟闲，惟人物更罕。此《蹴鞠图》尤为名迹，观其题句可以想象也。前月余正病卧榻，友人持至，与子久《富春剩山》同来，阅之觉身心俱快，病弱半失。静淑展之而笑曰：‘大黄一钱可以霍然。’为检商彝相易，置之枕畔者旬日乃付装。时戊寅（1938）十二月病起识之，坐观者内子潘静淑同署，时在梅景书屋晴窗。吴湖帆识。”</p>'
          },
          {
            x: 1026,
            y: 108,
            content: '<p>吴湖帆题跋：“聚识人闲混等伦，岂殊凡翼与常麟。一朝龙凤飞天去，总是攀龙附凤人。青巾黄袍者，宋太祖也；对蹴鞠者，赵普也；青巾衣紫者，太宗也；居太宗之下乃石守信也；巾垂于前者党晋也；年少青衣者，楚昭辅也。嘉靖己酉（1549）七月十四日，征明识。按嘉靖廿八年己酉为公历一千五百四十九年，越今三百九十六年矣。余曾见文氏摹钱氏本题此诗记，因录入。甲申（1944）冬日吴湖帆。”</p>'
          }
        ]
      }
    ]
  },
  'life1-45513': {
    caption: '明 唐寅 骑驴思归图轴',
    thumbnail: gallery['life1-45513-0.jpg'],
    description: '<p>绢本 设色</p><p>唐寅（1470-1523），字伯虎、子畏，号六如居士等。</p><p>此唐寅精品，吴湖帆以家藏毛钞《盘洲乐章集》册，以及宋椠河上本《道德经》与蒋祖诒换得。吴氏崇尚南宗，推崇元代文人画风，但吴门画派中唐寅的画风亦给他很大的影响。</p>',
    slides: [
      {
        url: gallery['life1-45513-1.jpg'],
        points: []
      }
    ]
  },
  'life1-45517': {
    caption: '明 沈周 西山纪游图卷',
    thumbnail: gallery['life1-45517-0.jpg'],
    description: '<p>纸本 水墨</p><p>沈周（1427-1509），字启南，号石田，长洲（今江苏苏州）人。</p><p>此图系沈周出宋藏经纸，辅以佳墨而成，故兴酣笔畅，点染淋漓，吴湖帆跋中称“早岁之作以故宫所藏《庐山高》轴（现藏台北故宫博物院）为第一”，“晚岁所作应以此卷为第一”，并题为“梅景书屋沈画第一”。</p><p>图绘吴中胜景，且又是明四家之首所作，作为同乡后辈的吴湖帆自然格外珍重。为得此作，湖帆不惜以家藏郑思肖《兰花图》出售，得资后辗转获藏。</p>',
    slides: [
      {
        url: gallery['life1-45517-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 5525,
            y: 109,
            content: '<p>吴湖帆题跋：吴湖帆题跋释文：“石田翁《西山纪游图》卷纷披畅发，点染淋漓，撷董巨之精华，冶元四大家于一炉，盖晚年兴到时作也。所用宋金粟山藏经纸凡六卷有半，每卷纸二节，又另每纸合工部尺一尺七寸，另纸长六寸许，犹宋时印经旧接也。最后一节祇用一幅，计长二丈五尺七寸，下角钤‘白石翁’水印，款记另书一纸。王文恪七古一首题其后。吾家旧藏石翁画卷凡八，以《张公洞图》、《吴中奇境图》为最着，尚有《吴中山水》长卷早归他姓，余未及寓目，不知与此卷相纇否？此卷余于己卯（1939）始得之，神采焕然，较《张公洞》、《吴中奇境》最胜，且在所见石翁诸卷之上，堪称此老晚岁画中第一品也。明季藏张见阳家，近年遍处丧乱，由泰和萧氏流出，乃为余获，定为梅景书屋明画之冠。四月十五日，吴湖帆识。”</p>'
          }
        ]
      }
    ]
  },
  'life1-45526': {
    caption: '明 沈周等 四家集锦图卷',
    thumbnail: gallery['life1-45526-0.jpg'],
    description: '',
    slides: [
      {
        url: gallery['life1-45526-1.jpg'],
        points: [
          {
            x: 1898,
            y: 255,
            content: '<p>吴湖帆题跋：“成化三年丁亥所作，是年四十一岁，越三载庚寅而文唐始诞生，明代画坛牛耳舍公其谁。余获于甲戌之春适四十一岁，湖帆志喜。”</p>'
          }
        ]
      },
      {
        url: gallery['life1-45526-2.jpg'],
        points: [
          {
            x: 1901,
            y: 234,
            content: '<p>吴湖帆题跋：“作于正德乙巳为王恪六十寿者。流入为文恪及门得意士，时年四十岁，笔致秀美，正才华焕彩时也。湖帆所得唐寅画甲观。”</p>'
          }
        ]
      },
      {
        url: gallery['life1-45526-3.jpg'],
        points: [
          {
            x: 1890,
            y: 259,
            content: '<p>吴湖帆题跋：“仇氏纸本画殊少见，此图用笔之精与江南春卷可争胜。图中景物似是孤山故事，人物神情精到非他人可及，亦仇画中隽品也。湖帆珍藏。”</p>'
          }
        ]
      },
      {
        url: gallery['life1-45526-4.jpg'],
        points: [
          {
            x: 1899,
            y: 233,
            content: '<p>吴湖帆题跋：“此图未着年月，玩其用笔款书，盖五六十岁时所作。临川李氏旧藏，四卷中余得之最晚，四美方具，深自庆幸翰墨缘分不浅，湖帆识。”</p>'
          }
        ]
      },
      {
        url: gallery['life1-45526-5.jpg'],
        points: [
          {
            x: 1843,
            y: 413,
            content: '<p>卷为“明四家”沈周、唐寅、文征明、仇英以及同时期相关书画家作品集锦卷，据吴跋自述，他为了集齐四家手卷先后寻访历时四十四年，体现出他作为收藏家在古代书画收藏方面的长期用功、精神投入和情趣所在。四画中沈周仿宋李唐《渔隐图》系作者四十一岁所作。唐寅《文会图》系四十岁时为师长、书法家王鏊六十寿辰精心所绘。吴湖帆鉴藏时多有拼拆配凑之举，本卷中王鏊《自作六十寿诞词》即从它卷中移出后拼入，这种带有专业性质的雅玩方式是梅景书屋鉴藏活动中的一大特色。</p>'
          }
        ]
      },
      {
        url: gallery['life1-45526-6.jpg'],
        points: [
          {
            x: 1769,
            y: 192,
            content: '<p>吴湖帆题跋：“明季以来，未闻有将四大家画相仿尺幅集成一卷者。余自甲戌（1934）获沈石田《渔隐图》，迄丁酉（1957）获文衡山《有竹图》，先后凡廿四年。其间先收仇十洲《访梅》一帧，后遇唐六如《文会图》，又有二十年之经过。最后文画以石田《峦容川色图》及陈白阳《洛阳春色图》二卷易得，亦余沉浸于画中五十年之狂举乎！戊戌（1958）七月初秋装成记。”</p>'
          }
        ]
      }
    ]
  },
  'life1-45530': {
    caption: '元 倪瓒等 行书题跋水竹居卷',
    thumbnail: gallery['life1-45530-0.jpg'],
    description: '<p>至正二十二年（1362）</p><p>纸本 水墨</p><p>本书卷为吴湖帆收藏中十分重要的作品。其前半图绘部分系张大千仿造，而题跋部分自盛麟以后八家，如曹诜、陆广、倪瓒、陶宗文等皆为元人所题真迹。据倪云林跋语，所题原图应为俞倬的私园水竹居而作。但有趣的是，这八位元人题跋真迹，在乾隆八年（1743）时还曾被系于过云楼旧藏元吴镇《与柯九思、赵天裕、赵原、顾安、张绅七君子图》（现藏苏州博物馆）卷后，亦为伪配。历史上这种真伪交集的手段，为古书画鉴定提供了一个极具启发性的实例。</p>',
    slides: [
      {
        url: gallery['life1-45530-1.jpg'],
        zoomLevel: 10,
        points: []
      }
    ]
  },
  'life1-45539': {
    caption: '元 张中 芙蓉鸳鸯图轴',
    thumbnail: gallery['life1-45539-0.jpg'],
    description: '<p>至正十三年（1353）</p><p>纸本 水墨</p><p>张中（十四世纪），字子政，松江（今属上海市）人。擅水墨花鸟，传世作品罕见，多为内府收藏。据《丑簃日记》载，1935年春，画商曹友卿携此画至梅景书屋，吴湖帆爱不释手，遂以戚继光《王瞻美五十寿诗》和张复《凤笙明月图》书画诗卷两件明代书画，并加800元现金换得，总计“约六千金”。</p>',
    slides: [
      {
        url: gallery['life1-45539-1.jpg'],
        points: [
          {
            x: 2069,
            y: 53,
            content: '<p>吴湖帆题跋：“元张子政《芙蓉鸂鶒》上上神品。子政工花鸟，与王若水齐名，为元代两大巨擘。据画石称，其山水宗黄子久，亦能墨戏。其所作山水真迹余固为之见也，其写生花鸟惟清宫旧藏之《桃花春鸟》与《枯荷鸂鶒》二图及此真迹，祇三品而已。余所观者多不可信。此帧有御览五宝，知亦《石渠宝笈》中物。兹就真迹三品以揅索子政画法，则简古渊穆是其本色。至《桃花春鸟图》，因题者众多而名亦最重，然摹本亦至伙，余所寓凡五本，竟无一真迹。此帧笔法，章法与《枯荷鸂鶒》绝相似，可定为一时之作，实斠《桃花春鸟》为胜。乙亥（1935）之春获于海上，以戚少宝与王元美昆弟《凤笙明月图》书画试卷，复益以巨金得之，以为梅景书屋元画甲观也。吴湖帆。”</p>'
          }
        ]
      }
    ]
  },
  'life1-50258': {
    caption: '清 王时敏 仿古山水图册',
    thumbnail: gallery['life1-50258-0.jpg'],
    description: '<p>康熙六年（1667）</p><p>纸本 水墨/设色</p><p>王时敏（1592-1680），字逊之，号烟客，江苏太仓人。清初“四王”之一。此图作于康熙六年（1667），作者时年七十六岁。</p><p>据吴湖帆《吴氏书画记》中所载，此册原为蒋祖诒所藏，甲戌（1934）春，吴湖帆“于密韵楼过读数次，实堪艳羡，乃以家藏第一宋钧窑洗与定窑碗、汝窑、官窑三碟，凡五宋瓷易得之，以为梅景书屋藏四王、吴、恽画事之冠冕云。乱世闲情，聊足自慰耳”。足证此册之至精。</p>',
    slides: [
      {
        url: gallery['life1-50258-1.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-2.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-3.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-4.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-5.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-6.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-7.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-8.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-9.jpg'],
        points: []
      },
      {
        url: gallery['life1-50258-10.jpg'],
        points: []
      }
    ]
  },
  'life1-19944': {
    caption: '明 吴伟 铁笛图卷',
    thumbnail: gallery['life1-19944-0.jpg'],
    description: '<p>成化二十年（1484）</p><p>纸本 水墨</p><p>吴伟（1459-1508），字士英，号小仙，江夏（今湖北武昌）人。此图作于1484年，作者时年二十六岁。</p><p>此图原为梁清标旧藏，旋入乾隆御府，后从宫中流出被颜世清购入，1931年吴湖帆以一千八百金购藏，题为“天下小仙画第一”。</p><p>清朝末代皇帝溥仪随意将宫中藏品赏赐臣工，又大肆窃取宫中书画。其中部分被变卖，为当时京津沪等地画商、藏家购得，吴湖帆及其友人亦有斩获。</p>',
    slides: [
      {
        url: gallery['life1-19944-1.jpg'],
        points: [
          {
            x: 19813,
            y: 101,
            content: '<p>吴湖帆题跋：“天下第一吴小仙画。明张伯起，清梁蕉林、周雪客、姜二酉、高宗内府、颜韵伯递藏。吴湖帆题。”</p>'
          },
          {
            x: 13855,
            y: 130,
            content: '<p>祝允明题跋：“会稽老壑生黑金，神嘘鬼吸具五音。山灵不宁持送帝，教具口耳人间吟。豪来哮吼艷调笑，崑山玉碎凤皇叫。残簧一片在故宫，拾取磨成琯六窍。雌龙响歇小女持，铁精坐调双花枝。大枝拈枝对郎插，小枝掩扇诲妖痴。呈妖献调今小仙，张卿友之殊爱怜，老歌翻转识面面，休道瞒它四十年。长洲祝允明赋。”</p>'
          },
          {
            x: 753,
            y: 212,
            content: '<p>吴湖帆题跋：“小仙生天顺己卯（1459），《铁笛图》作成化甲辰（1484），年才二十有六，正少年孟晋作时也。召授锦衣镇抚，待诏仁智殿，时年未满三十。孝宗弘治年元（1488），祇三十岁，授锦衣卫百户，赐书状元印。自来画家年少知遇之隆无有过之。惜天靳其寿，卒只年五十耳。祝希哲少小仙一岁，此诗书殆亦二十许而已，然如万岁枯藤、偃蹇虬龙之妙，宜乎为有明一代书家冠冕也。二人老皆狂放，此俱庄严，可谓合璧。癸酉（1933）中秋重装，灯下识此，吴湖帆梅景书屋。”</p>'
          }
        ]
      }
    ]
  },
  'life1-45531': {
    caption: '北宋 米芾 行书多景楼诗册',
    thumbnail: gallery['life1-45531-0.jpg'],
    description: '<p>纸本</p><p>米芾（1051-1107），湖北襄阳人。是册为米芾居镇江时，登临北固山甘露寺多景楼，触景生情所作。字大如拳，笔势开张，向被视作米氏传世大字佳构。</p><p>抗战胜利前夕，吴湖帆将此重宝收入囊中，珍视逾常，其书斋冠名“梅景书屋”次字“景”即寓意于此，又于多处题跋提及宝爱之重，足见这件作品对于吴氏不同凡响的意义。</p>',
    slides: [
      {
        url: gallery['life1-45531-1.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-2.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-3.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-4.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-5.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-6.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-7.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-8.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-9.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-10.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-11.jpg'],
        points: []
      },
      {
        url: gallery['life1-45531-12.jpg'],
        points: [
          {
            x: 1876,
            y: 632,
            content: '<p>吴湖帆册首题跋：“宋米南宫书多景楼诗真迹与梁永阳昭王敬太妃双志宋拓孤本，又宋刻梅花喜神谱、元吴仲圭渔父图卷真迹为吴氏所藏文物四宝，吴湖帆珍秘并记。”</p>'
          }
        ]
      }
    ]
  },
  'life2-31536': {
    caption: '南宋 林椿 梅竹寒禽图页',
    thumbnail: gallery['life2-31536-0.jpg'],
    description: '<p>林椿（十二世纪），钱塘（今浙江杭州）人，淳熙间（1174-1189）中画院待诏。工花鸟、草虫、果品，以赵昌为师；设色清淡，精工逼真。本图画红梅翠竹，残雪未消；寒禽梳羽，神态生动，为林氏花鸟画杰作。</p><p>此为吴湖帆、潘静淑夫妇移居沪上后入藏，与其购藏的南宋佚名《鹌鹑图》页大抵同时，据此不难发现其这一时期收藏趣味之所在。</p>',
    slides: [
      {
        url: gallery['life2-31536-1.jpg'],
        points: []
      }
    ]
  },
  'life2-31601': {
    caption: '南宋 佚名 鹌鹑图页',
    thumbnail: gallery['life2-31601-0.jpg'],
    description: '<p>本图作者不详，所作鹌鹑神态生动活泼，坡后秋禾一茎，亦摇曳生姿，堪称南宋写生佳作。</p><p>此为二十世纪三十年代中期之前，吴湖帆、潘静淑夫妇移居上海之后购藏。从画面内容以及同时前后购藏的南宋佚名《樱桃黄鹂图》页、南宋林椿《梅竹寒禽图纨扇》页中，略可窥见吴氏夫妇当时追求和向往一种恬淡、安宁、祥和的生活情趣。</p>',
    slides: [
      {
        url: gallery['life2-31601-1.jpg'],
        points: []
      }
    ]
  },
  'life2-39393': {
    caption: '南宋 佚名 樱桃黄鹂图页',
    thumbnail: gallery['life2-39393-0.jpg'],
    description: '<p>绢本 设色</p><p>本图作者不详，题者系南宋宁宗杨皇后。杨皇后（1162-1233），会稽（今浙江绍兴）人。本图画面意境，于吴湖帆《黄鹂绕碧树》词题咏一一呈现。从吴氏题跋可知，该图似其得自上海解放前夕。因吴湖帆极珍视此图页，故以家藏古籍善本易得，并于二十世纪五十年代初邀约海上女画家周炼霞，以共赏雅集的形式欢度新春。</p>',
    slides: [
      {
        url: gallery['life2-39393-1.jpg'],
        points: [
          {
            x: 2061,
            y: 1943,
            content: '<p>吴湖帆题跋：“黄鹂绕碧树，用周清真韵。春色迎人，媚珠帘，玉苑唱随朝暮，小印拈红映修眉，黛碧染香，纨素并肩，笑语指樱颗，宫砂柔绪，廻倚槛，听啭黄鹂，又喜和鸣声煦。此日杨家，秀吐尽欢娱，浣花无虑，且闲戏试，坤宁睿笔，清閟芳土，谩使凤城，麝霭便洒得，韶光住，凭将丽景，裁奁翠华凝树。己丑（1949）春日，兵戈仓皇中，获见此图，典书相易，以遣积怀，亦离乱间，一快事焉。吴湖帆题于迢迢阁。”</p>'
          },
          {
            x: 258,
            y: 1893,
            content: '<p>周炼霞题跋：“癸巳（1953）新春同观，抱真、炼霞。”</p>'
          }
        ]
      }
    ]
  },
  'life2-45516': {
    caption: '清 王原祁 仿梅道人山水图轴',
    thumbnail: gallery['life2-45516-0.jpg'],
    description: '<p>康熙四十二年（1703）</p><p>纸本 水墨</p><p>王原祁（1642-1715），字茂京，号麓台。江苏太仓人。清初“四王”之一。此图是作者六十二岁时所作。</p><p>本图为清廷赏赐大臣英和并流落民间的古书画之一。围绕一方“扬儿”小印的归属，吴湖帆饶有兴味地展开赏鉴。因吴氏有一儿名“扬儿”，其诞生之年的甲子恰与创作此画的干支年份癸末（1703）同，只是晚了二百四十年。藏家喜爱强调作品与自己或家人之间的因缘，也正因为一些巧合而收藏一件作品，这也体现出鉴藏活动中颇有意思的一面。</p>',
    slides: [
      {
        url: gallery['life2-45516-1.jpg'],
        points: [
          {
            x: 1839,
            y: 690,
            content: '<p>吴湖帆题跋：“司农梦笔梅沙弥，癸未初春画诞时。我属前身老渔父，奇缘小印识扬儿。王麓台司农作画于康熙四十二年癸未（1703）之春，仿梅道人笔。正越二百四十年，岁次癸未正月十四日，我扬儿生逾月，得此画，而右下角有‘扬儿宝玩’小印，洵奇缘焉？画上有乾隆御览玺印四方，为宝笈重编之品。下有‘赐本’及‘臣和恭藏’二印，盖清高宗御赐英煦斋相国者。扬儿一印其色与英氏印略同，是否亦英氏所钤？或英氏诞生扬儿者，而高宗御赐此画因钤小印为识？未可考也。不然，亦从无以某儿为名贸钤于御赐名画之上之理。又十余年前，余曾收梅道人《渔父图》卷，亦清宫御览之宝，是皆吾永为珍藏镇家品也。丁亥（1947）春正重装，吴湖帆识于梅景书屋。”</p>'
          }
        ]
      }
    ]
  },
  'life2-45520': {
    caption: '清 王鉴 仿宋元十六家山水图册',
    thumbnail: gallery['life2-45520-0.jpg'],
    description: '<p>康熙四年（1665）</p><p>纸本 水墨/设色</p><p>此图册作于清康熙四年，作者时年六十八岁。</p><p>此册吴湖帆每开皆题识甚详，称此册为其寓目王鉴画册真迹第二十五本。 内有吴氏题跋指梅花图请潘静淑赏鉴一段，吴湖帆夫人潘静淑喜爱梅花题材的书画，屡有收藏临摹，对历代梅画甚为熟悉，故吴就此图疑问与之探讨。后页又附一纸记录关于此画题诗作者的考证，云据吴侄潘蘧盦鉴定，此诗作者应为清代岭南派书画家屈大均。</p>',
    slides: [
      {
        url: gallery['life2-45520-1.jpg'],
        points: [
          {
            x: 316,
            y: 1112,
            content: '<p>吴湖帆题跋：“此册初为一收旧货担者得于败簏中，零乱不整，以一元六毛得之。盖自丁丑变乱后劫余物也，后转展至此，不知几经骨董人手矣。”</p><p>吴湖帆题跋：“后有伴梅诗题一页，亦康熙时原装也。诗中与玄照似无关系，且不详为何许人。审其笔致殆类女史，应质静淑以为何如。”</p>'
          }
        ]
      },
      {
        url: gallery['life2-45520-2.jpg'],
        points: [
          {
            x: 931,
            y: 128,
            content: '<p>吴湖帆题跋：“右伴梅诗二首原装于玄照册后，虽未详姓氏，审其笔势与玄照为同时人。初疑出女史手笔，但诗句雄健，或非女史口气。今日内侄潘子蘧盦鉴赏曰，笔法书体颇似岭南屈大均。盖蘧盦收藏历代尺牍将万通，搜罗名贤笔迹至富，看成东南首屈，其鉴别素精确，当非无因也。惟据蘧盦云屈氏吴别号，伴梅二字，故不敢断言。乙卯春湖帆又识。”</p>'
          }
        ]
      }
    ]
  },
  'life2-45527': {
    caption: '元 佚名 山水三段图卷',
    thumbnail: gallery['life2-45527-0.jpg'],
    description: '<p>纸本 水墨</p><p>此图作者待考。卷中的《秋林远岫图》、《江岸乔柯图》和《江深草阁图》，系吴湖帆得于二十世纪三十年代后期；卷中所附管道升《双钩竹》，则来自友人钱镜塘之馈遗（1953年）。吴湖帆夫妇雅好书画，一向追慕赵孟頫、管道升韵事，故吴湖帆于入藏山水三段卷后十五年获得管氏画竹，追忆原配不胜唏嘘，题词以记，与之共同观画的上海女画家周炼霞亦以原调原韵唱和于后。</p>',
    slides: [
      {
        url: gallery['life2-45527-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 2726,
            y: 103,
            content: '<p>吴湖帆题跋：“藏松雪翁此卷十五年乃获魏国夫人画竹为俪，不禁怅然，自足系以词。《鹧鸪天》：春雨楼头结绮思，有情眷属总相期，鸥波定论千金诺，梅屋除开片玉遗。齐四美，合双栖，玉台佳婚倩重题，画堂松雪珠帘卷，紫燕归来倒好嬉。”</p>'
          },
          {
            x: 2328,
            y: 117,
            content: '<p>周炼霞题跋释文：“艷说沤波倒好嬉。生花采笔有连枝。双钩细勒春烟紫，淡染浓皴螺黛宜。真美具，二难齐。迢迢阁上忽相期。明珠宝剑难还合，终古因缘属阿谁。癸巳春分前二日，随声鹧鸪天。罗川炼霞题。”</p>'
          }
        ]
      }
    ]
  },
  'life2-47219': {
    caption: '清 恽寿平 花卉图册',
    thumbnail: gallery['life2-47219-0.jpg'],
    description: '<p>康熙二十四年（1685）</p><p>纸本 设色</p><p>此册为恽寿平没骨花卉精品，设色清雅，姿态娴美，开一代花鸟画之风气。经吴湖帆考证，此图册作于康熙二十四年，作者时年五十三岁。</p><p>潘静淑雅爱花鸟，吴氏重金为其购得此册。吴湖帆于此册一见倾心，然索值颇昂，踌躇一昼夜，将旧藏明清《文氏书画便面》册质去，再加巨金，方如愿购藏。</p>',
    slides: [
      {
        url: gallery['life2-47219-1.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-2.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-3.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-4.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-5.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-6.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-7.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-8.jpg'],
        points: []
      },
      {
        url: gallery['life2-47219-9.jpg'],
        points: [
          {
            x: 1776,
            y: 159,
            content: '<p>吴湖帆题跋：“余最爱南田翁花卉，盖其天资丰神堪称空前绝后，虽起徐、黄亦未必能过，其后如南沙、新罗亦跳不出其篱笼。十余年来所见极作卷册三四事，皆藏弆，藏家非力能致。曩岁静淑专习花卉，后颇欲收贮一二杰品以为摩挲，弗能得。今秋见此册从故都来，展觉神往，顾索值昂，踌躇一书夜，乃将旧藏明清文氏书画便面一册质去，复益巨金辇归，以成斯愿。余平生所见恽册都十许本，花卉六七，若此册之精彩焕发，祇一二数矣。冠册之白牡丹一帧，尤见清华朗润，凝脂耀月，光射十步也。是谓神品，谁曰不宜？戊寅（1938）冬日，吴湖帆识，潘静淑宝藏。”</p>'
          }
        ]
      }
    ]
  },
  'life2-51061': {
    caption: '清 恽寿平 秋花猫蝶图轴',
    thumbnail: gallery['life2-51061-0.jpg'],
    description: '<p>康熙二十三年（1684）</p><p>纸本 设色</p><p>恽寿平（1633-1690），初名格，字寿平，号南田。此图作于康熙二十三年，作者时年五十二岁。</p><p>是图以墨骨淡彩作花卉猫蝶，为吴氏夫妇十分赏爱之物。梅景书屋所藏一些特殊题材的古代绘画，往往为吴潘夫妇所共嗜者，比如梅花及猫。前者反映了吴潘夫妇以“梅花知己”自视的情怀，对于古今名家画猫之偏爱，则主要源于“夫人爱猫入骨，自小即如此”、“余夫妇有猫癖”，以及吴家遵循旧历金危危日画猫辟火的习俗。</p>',
    slides: [
      {
        url: gallery['life2-51061-1.jpg'],
        points: []
      }
    ]
  },
  'life2-59917': {
    caption: '宋拓 梁萧敷敬妃墓志铭合册',
    thumbnail: gallery['life2-59917-0.jpg'],
    description: '<p>此册为吴湖帆至爱之藏品，常加观摩赏玩、考订题咏，几十年间时有单独或与元配潘氏、继配顾氏共赏并识文字、印鉴见诸册端页间。夫妇唱随，沉潜金石学的精深执着，几与南宋李清照与丈夫赵明诚共同灯下考校碑版文字之精神投入相仿佛。</p>',
    slides: [
      {
        url: gallery['life2-59917-1.jpg'],
        points: []
      },
      {
        url: gallery['life2-59917-2.jpg'],
        points: [
          {
            x: 4224,
            y: 1239,
            content: '<p>吴湖帆题跋：“梁永阳王敬太妃墓志，吴氏双修阁珍藏至宝。吴湖帆潘静淑同记。”</p>'
          },
          {
            x: 921,
            y: 1269,
            content: '<p>潘静淑书跋：“南朝有志墓之禁，此奉敕所撰，乃特例也。王志渊穆，妃志峭劲，况为宋拓孤本，洵墨皇也。双修阁中，可无愧色。癸酉（1933）春，吴湖帆题，潘静淑书。”</p>'
          }
        ]
      },
      {
        url: gallery['life2-59917-3.jpg'],
        points: [
          {
            x: 1273,
            y: 269,
            content: '<p>“梁仆射徐勉，字修仁，工文章，当时丰功伟绩之文皆出其制。此永阳王敬太妃双志，咸为修仁奉敕所撰，因名吾室曰：双修阁。癸酉（1933）二月，吴湖帆、潘静淑记。”</p>'
          },
          {
            x: 822,
            y: 33,
            content: '<p>“南朝金粉浑如梦，壹城更怜凄晚。故雁分襟，新龙补衮，盛事宏文修翦。天情未掩。待嫠纬崇銮，玉鱼重簟。树满长干，乱鸦何计暮云卷。清风乡底井畔，翠珉慌卧久，肠断无限。王录齐收，陶钞一志，踪迹沉湮莫转。凝思代远。赏梁苑孤芳，宋场双荐。异趣宫装，隐居眉黛敛。清真《齐天乐》韵。清真此词，首句有‘绿芜凋尽壹城路’一语，自后宋元以来即用‘壹城路’为牌名。余故拈此调题之，对天监原刻，不无慨感云。”</p>'
          },
          {
            x: 258,
            y: 47,
            content: '<p>“六朝金粉都成梦，千古江山依旧时。己丑（1949）春正月既望，展读《梁萧敷敬妃双志》，拟用张僧繇法写图册端。吴湖帆并识，顾抱真理色于迢迢阁。”</p>'
          }
        ]
      }
    ]
  },
  'life3-19334': {
    caption: '明 陆治 元夜燕集图卷',
    thumbnail: gallery['life3-19334-0.jpg'],
    description: '<p>嘉靖二十六年（1547）</p><p>纸本 设色</p><p>陆治（1496-1576），字叔平，号包山，江苏苏州人。本卷为陆治应陆师道之请所作，图绘当年陆氏师生元宵时节，在文征明家园诗酒唱和的雅集情形。此图作于嘉靖二十六年，作者时年五十二岁。</p><p>此图系吴湖帆于1929年入藏。两年后，吴湖帆于潘静淑生日之时取出题咏，又邀冯超然等题识。十年后，吴湖帆将转让内弟的此图卷借归提看，元配潘氏已因病去世，故再作词追悼，不胜物是人非、物我牵情之慨。</p>',
    slides: [
      {
        url: gallery['life3-19334-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 6401,
            y: 276,
            content: '<p>吴湖帆题跋：“扫眉韵语属仙家，拂槛春风月露华。后日上元今日寿，画堂并结烛端花。团圞明月净无埃，满苑梅花取次开。灯火春宵如画裹，年年今夜醉千回。辛未（1931）正月十三日逢内子静淑潘夫人四十初度，因次卷中明贤韵题记。是日夫人之侄博山君酒量至豪，大醉而归，故末句及之，亦一时逸兴也。元宵吴湖帆识。”</p>'
          },
          {
            x: 1292,
            y: 204,
            content: '<p>吴湖帆题跋：“女冠子。辛巳（1941）上元灯节，逢潘夫人五十诞日，而夫人已作古人。回首十年，恍如梦影，重向博山内侄，借归斯卷一读，用蒋竹山韵，题词于后，愿博山长护也。上元时也。十年光景如画。团圆常照，几番欢笑，物我牵情，流光移射。心头千绪挂。说甚爆声燃竹，禁城通夜。叹天边、如水镜月，回影成双犹耍。诗灯灵谜猜谁打。念河阳春满，卷向包山借，玉台香炧。待韵语检点，谩熏遗帕，红罗纹且砑。细把旧欢新恨，忍书重话。愿吉云长护，碧纱笼处，宝山楼下。宝山楼，博山、景郑贤昆仲藏书处也。年时多病，手亦颤矣，不自藏拙，漫书于此，盖亦情之所不能已也。希博山贤侄勿粲。倩庵。”</p>'
          }
        ]
      }
    ]
  },
  'life3-35731': {
    caption: '明 陈楫 虎丘十二景图册',
    thumbnail: gallery['life3-35731-0.jpg'],
    description: '<p>纸本 设色</p><p>陈楫字莱山，号济之，吴郡人。明万历间以画名于时。</p><p>本图册为张大千所赠，所画皆吴湖帆家乡苏州地区胜景。从梅景老人所强调的“珍藏乡邦文物”话语，亦可见其收藏旨趣之一斑。</p>',
    slides: [
      {
        url: gallery['life3-35731-1.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-2.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-3.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-4.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-5.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-6.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-7.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-8.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-9.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-10.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-11.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-12.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-13.jpg'],
        points: []
      },
      {
        url: gallery['life3-35731-14.jpg'],
        points: [
          {
            x: 1718,
            y: 310,
            content: '<p>吴湖帆题跋：“陈楫，字莱山，号济之，吴郡人。明万历间以画名于时。与王仲山（问）友善，仲山画间出济之捉刀（见故宫周刊仲山山水一幅即陈笔也）。此册之前原有仲山书引首四字及文伯仁画虎阜全景一幅，王文肃、王弇州等数跋（钱余初见时未皆佚），旋被庸工割裂，充市贾酒资矣，不胜惋惜。后此册为张大千兄所见，以吾吴景物购之相赠云，甲戌冬日吴湖帆识。”</p>'
          }
        ]
      }
    ]
  },
  'life3-45524': {
    caption: '元 王㽘等 诸家题倪瓒耕云轩咏卷',
    thumbnail: gallery['life3-45524-0.jpg'],
    description: '<p>皇庆二年（1313）</p><p>纸本 水墨</p><p>此卷分为两部分，前一部分为王㽘、卢熊、张适、高启、僧衍、徐达左、黄本之间的唱和。后一部分是明人黄姬水、周天球、王穉登对倪瓒为王.所画《耕云轩图》的题跋，题咏前贤皆是吴人，吴湖帆常言“吾吴”，可见其对故乡的文化传统十分自豪，对于吴地书画家作品的搜罗亦不遗余力。此卷为吴氏夫妇以千金紫貂裘换得，又于跋中痛惜倪瓒原画之佚失，表示将其与黄公望、吴镇、王蒙的名卷同藏，希望有一天能够得元四家长卷完璧的心愿。</p>',
    slides: [
      {
        url: gallery['life3-45524-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 11487,
            y: 128,
            content: '<p>王㽘题咏 ：“畂衰惫之踪未堕沟壑，抱疾居凤凰山先壠之侧，与海云相去咫尺。愚庵师兄自径山退席家林，笃念先清献契义，日夕往还，情过骨肉。畂以艰难偶适海津，岁阑冰雪，时沭见思形于歌咏，敢当何如？谨依高韵以谢焉。老弟王畂端肃奉呈。偶为放浪游，飘泊无定处。遥忆海云深，天华遶琼树。扁舟宿海际，岁阑犹未归。山色梅华裹，相思逐梦飞。艰难阻河冰，天寒厌为客。凉月满空舟，午夜闻灵鹊。时癸丑（1313）正月三日书于耕云山居。”</p>'
          },
          {
            x: 8359,
            y: 282,
            content: '<p>高啓和诗 ：“千峰一寺远，雪满跏趺处。无客伴孤禅，悬灯照祗树。钟动云壑暝，鹤归人不归。何当蹑金策，同向海天飞。月明夜猿起，遥忆孤舟客。旧树有安巢，莫作南飞鹊。高啓次韵”。</p>'
          },
          {
            x: 4002,
            y: 128,
            content: '<p>周天球和诗：“云林子清逸高古，艺能亦然。今吴中人士称好事博雅者，购得片纸便自谓名下不虚，然不易得也。其平生作横卷闻止有三，《耕云》居一，此尤艰致者，近归谈太常思重，得借阅经旬，明窗展拂，能令人意消，余亦从此不溷于俗矣。六止居士周天球题。”钤：“六止居士”、“周氏公暇”白文方印。</p>'
          },
          {
            x: 3401,
            y: 127,
            content: '<p>王穉登和诗：“嬾公书法绝远时辈，晚岁入董巨之室。观此卷林岫濯濯，萧然有高世之致。耕云子者，余不知为何人，便思荷衣萝带偕隐其间也。壬申（1572）闰月，与思重太常同泛娄江，舟中阅此图敬题。太原王穉登。”</p>'
          },
          {
            x: 1758,
            y: 125,
            content: '<p>吴湖帆题跋：“余既得黄子久富春山居图烬余卷，未及经年，又得此耕云轩图咏卷。皆明梁溪谈思重太常故物，惜云林之画今不复存，只存元明贤诗跋十家而已。按清高宗三题犹云屡和云林韵题于画幅，可知此画佚于乾隆之后，洵艺林中大憾事也。昔人云大宝忌完，亦是达人语也。题中元贤如王㽘已得清高宗揭注，若卢熊、高启、徐达、左僧衍皆有名传，张适亦吴人。忆故内府所藏元贤把家画卷皆张适旧物，只黄本尚未详俟考，明三家皆吾吴嘉隆名贤，毋庸余赘。是卷旧藏吾苏彭氏，十余年前余曾见之，未能力致。丁丑乱离中复见于海上，如逢故旧，遂收入为梅景书屋长物，与子久富春残卷、仲圭渔父图卷、叔明松窗读易图卷同贮以俟高士原迹纸归来云。乙卯吴湖帆潘静淑同记。”</p>'
          }
        ]
      }
    ]
  },
  'life3-45535': {
    caption: '明人诗牍册',
    thumbnail: gallery['life3-45535-0.jpg'],
    description: '<p>吴湖帆喜爱以一个主题将藏品集册或集卷，尤其喜爱汇集苏州乡贤的作品，移入移出拼配的现象也时有发生。比如本集册中申时行《游天平山诗》页，原与王鏊《自作六十寿诞词》合装一卷，后为吴湖帆拆分，将王鏊《自作六十寿诞词》移配《明四家集锦卷》，与唐寅为王鏊所绘《文会图》呼应，，而申氏此诗页则与册中其它吴门文人如文征明、唐寅、祝允明等诗牍合册。</p>',
    slides: [
      {
        url: gallery['life3-45535-1.jpg'],
        zoomLevel: 2,
        points: []
      },
      {
        url: gallery['life3-45535-2.jpg'],
        zoomLevel: 2,
        points: []
      },
      {
        url: gallery['life3-45535-3.jpg'],
        zoomLevel: 2,
        points: []
      },
      {
        url: gallery['life3-45535-4.jpg'],
        zoomLevel: 2,
        points: []
      },
      {
        url: gallery['life3-45535-5.jpg'],
        zoomLevel: 2,
        points: [
          {
            x: 971,
            y: 143,
            content: '<p>吴湖帆题跋：“右吾吴明贤诗帖精品一册，余集之十年矣。凡诗用其题标目，手牍则检文中首句或主事名之曰帖，盖仿阁帖名二王书例也。吾吴在明嘉隆时，文物之盛甲海内，枋国文豪齐肩辈出。五百年前风流盛业，至今凭仗纸墨之传，集成一帙，亦足以回瞻贤型而已。岁在甲戌（1934）十二月三十日除夕夜跋，邑人吴湖帆。”</p><p>“此册虽寥寥二十余通，然皆吾乡先贤手泽，为可珍。而自来藏者不一，若项子京、朱卧庵、缪文子、安仪周、乔润斋、陆丹叔、顾乡舟、狄曼农等皆著名收录家数，具有钤印可稽。及吾而聚于一帙，是亦翰墨缘也。校竟重记，时已三鼓。”</p>'
          }
        ]
      }
    ]
  },
  'life3-64771': {
    caption: '清 金俊明 群芳合璧图册',
    thumbnail: gallery['life3-64771-0.jpg'],
    description: '<p>顺治十七年（1660）</p><p>纸本 水墨/设色</p><p>金俊明（1602-1675），字孝章，号耿庵，江苏苏州人。此册为作者墨戏自赏之作，作于顺治十七年时年五十九岁之际，画后又请好友一一补缀各种花卉松竹以成。</p><p>有关家世、乡谊、与吴门风土人情以及吴氏家族相关的古代书画，是梅景书屋所藏之另一特色。金俊明群芳合璧图册既为祖传，画家金氏所居“春草闲房”原址又是吴家苏州祖上旧居，加之梅花题材系吴潘最爱，可谓是汇聚了浓厚家族亲情的藏品，故深得吴湖帆喜爱，每年元旦必检出与家人共同捧读。</p>',
    slides: [
      {
        url: gallery['life3-64771-1.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-2.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-3.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-4.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-5.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-6.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-7.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-8.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-9.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-10.jpg'],
        points: []
      },
      {
        url: gallery['life3-64771-11.jpg'],
        points: [
          {
            x: 2223,
            y: 1179,
            content: '<p>吴湖帆题跋;“吾家旧居双林巷春草闲房，孝章先生故里也。先祖收得先生画梅册凡三，以此为冠。又先生手书诗稿一卷，皆丙戌（1646）、丁亥（1647）时作语，多凄感，盖身世与所南仿佛耳。此册曾装于光绪戊申（1908），先父录作家小传于后，越今又廿余年矣。重付潢池题之，时辛未（1931）十月，吴湖帆。”</p>'
          }
        ]
      },
      {
        url: gallery['life3-64771-12.jpg'],
        points: [
          {
            x: 1689,
            y: 768,
            content: '<p>潘静淑题跋：“年年元旦，湖帆必以此册在梅景书屋共读。右吴霜厓师题于壬申（1932），时逢倭寇海上。距今七年，而第二次乱事又逢矣，可叹可叹。戊寅（1938）元日静淑记。”</p>'
          },
          {
            x: 684,
            y: 249,
            content: '<p>吴湖帆题跋;“ 伫花阴，系离愁几许，仙格解毫簪。涕泪家常，宫商国破，英气都付消沉。忆春草，闲吟自足，羡月满，枝上并栖禽。密护情同，暗浮香合，何日重临。 犹记去年元夜，有华灯照恨，玉笛吹心。疏影黄昏，纹窗惨绿，温梦轻从。难承恨，空负林泉旧约，剩螺黛，残粉重千金。却怨修眉未舒，墨浅愁深。” “己卯（1939）元日，余适病起，静淑更形欣快，并以曩岁合临本重加点染。越今岁周，而夫人已为古人，残烛青灯，不胜凄然泪下，元日之夜，复检读是册，以消孤怀，然适足以增余之悲也。十三日正夫人诞辰，因依白石《一萼红》韵题记，庚辰（1940）湖帆。”</p>'
          }
        ]
      }
    ]
  },
  'life4-45537': {
    caption: '明 徐渭 草书春雨帖七古二章卷',
    thumbnail: gallery['life4-45537-0.jpg'],
    description: '<p>纸本</p><p>徐渭（1521-1593），字文清、文长，号天池、青藤等，山阴（今浙江绍兴）人。此书作于隆庆元年，作者时年四十七岁。</p><p>二十世纪上半叶，藏友间互通有无性质的馈赠颇为流行，体现了当时的文人雅玩风尚，梅景书屋亦不例外。此卷为徐渭草书，卷前清人《徐渭肖像》系吴氏弟子王季迁所赠，吴湖帆将两者装为一卷。徐渭擅草书，狂放不羁而不逾法度，吴湖帆欣赏此种特色，于此卷非常珍重，多次题跋，对其风格、源流、流传考证详尽。</p>',
    slides: [
      {
        url: gallery['life4-45537-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 31211,
            y: 290,
            content: '<p>吴湖帆题跋：“季迁研弟近于故家纸簏中购得其先德王文恪公与徐山人二象。标题、画像皆康熙间人手笔，顾古雅可玩。《文恪象》，季迁装之家书卷。《山人象》以贻我，廼装于此。癸酉（1933）春日吴湖帆记。”</p>'
          },
          {
            x: 29867,
            y: 103,
            content: '<p>“明徐文长春雨帖真迹。仿宋人于二王命名之意，取帖首两字为名，此卷第二字笔误，即取其误字为名，尤为切合。使千百年后当易识别也。湖帆又志。”</p>'
          }
        ]
      }
    ]
  },
  'life4-45540': {
    caption: '明 文俶 墨梅图轴',
    thumbnail: gallery['life4-45540-0.jpg'],
    description: '<p>天启七年（1627）</p><p>纸本 水墨</p><p>文俶（1595-1634），字端容，文征明玄孙从简之女，嫁与从父受业的赵灵均。天性明慧，善绘花鸟草虫。此图梅花出以墨笔，轻描简勾，鲜妍生动，配之以苍遒树干，尽得性情。作于天启七年，时年三十三岁。</p><p>从跋文中可知，梅景书屋收藏的历代女性创作，与女主人潘静淑的研习息息相关。而主人吴湖帆的自我期许，夫妇二人诗文书画兼修的造诣，堪与元代赵孟頫、管道升和明代赵灵均、文俶伉俪媲美。</p>',
    slides: [
      {
        url: gallery['life4-45540-1.jpg'],
        points: [
          {
            x: 254,
            y: 1145,
            content: '<p>潘静淑题跋释文：“亭亭清绝，香远霏帘隙。独倚阑干情脉脉，相对无言谁识。恁时小谪人间，已经三百余年。本是瑶台仙种，尘缘偕隐寒山。丁丑上元戏调《清平乐》，前距赵夫人画时已三百十又一年矣，乡后学潘静淑。”</p>'
          },
          {
            x: 1720,
            y: 27,
            content: '<p>吴湖帆题跋释文：“明赵夫人文端容画疏影横斜图真迹。赵夫人画高华琼绝，僊骨娉婷，管仲姬后一人而已。当明末季与灵均高士偕隐寒山，以书画娱晚，所写虫蝶可称空前。此图暗香浮动，疏影横斜，尤见高逸，虽金孝章、邵僧弥未能过也。宜南楼、江香俱当下拜矣。静淑近岁习画后，所贮女史杰构殊多，此其冠乎。丁丑（1937）上元节日，吴湖帆梅景书屋题。”</p>'
          }
        ]
      }
    ]
  },
  'life4-47327': {
    caption: '清 李因 芙蓉鸳鸯图轴',
    thumbnail: gallery['life4-47327-0.jpg'],
    description: '<p>康熙九年（1670年）</p><p>纸本 水墨</p><p>李因（1616-1685），葛征奇之妾，夫妇皆善绘事。此图作于康熙九年，作者时年五十五岁。</p><p>潘静淑自幼浸淫在收藏世家氛围中，及长，嫁于吴湖帆。夫妇二人皆痴迷书画一道，庋集、摹古、创作不辍。潘静淑尤喜收藏历史上闺阁画家之作，时时临写。对于历史上夫妻共同收藏、创作的书画，作为书画家和收藏家伉俪的吴湖帆、潘静淑夫妇则尤喜收蓄。</p>',
    slides: [
      {
        url: gallery['life4-47327-1.jpg'],
        points: []
      }
    ]
  },
  'life4-50143': {
    caption: '明 马守真 薛素素 兰花图卷',
    thumbnail: gallery['life4-50143-0.jpg'],
    description: '<p>纸本 水墨</p><p>马湘兰（1548-1604），一名守真，号月娇，金陵名妓。薛素素，字素卿，小字润娘，明万历年间秦淮名妓。此图马氏作于万历三十二年，作者时年五十七岁。</p><p>潘静淑好画精鉴，“所贮女史杰构殊多”，为梅景书屋鉴藏一大特色。此画卷经吴梅、汪东等词学名宿和叶恭绰、冯超然等名家挥毫唱和，愈加可观。从跋文可知，吴湖帆决定将此卷转赠钱镜塘，与之所藏的相关信札合璧，堪称海上收藏界的美谈。</p>',
    slides: [
      {
        url: gallery['life4-50143-1.jpg'],
        zoomLevel: 30,
        points: [
          {
            x: 30352,
            y: 109,
            content: '<p>吴湖帆题跋：“马四、薛五画，余所见几及百事，而真迹百不得一二。马虽佳品亦不少，半为后来好事者歌吹所成，决非真迹。此卷款识、笔法无不神具骨透，余费十余年搜罗而得，真敢云马、薛真迹。幸读者勿以寻常香签品忽之，是殆余赏画知己。吴湖帆识于卷首。”</p>'
          },
          {
            x: 12745,
            y: 143,
            content: '<p>吴湖帆跋词：“看幽香凝粉，芳意动奁，画眉余韵流照。浅抹猩唇，慢拈凤爪。检点离痕多少。恨叶愁根，露纫风畹，生来娇小。似并鬟、珠璧玲珑，仿佛朝云琴操。南部歌声悄悄，（此日正金陵首都风万废娼时也。）任秦淮月（‘去’声）冷，莫愁风晓。认春色三分，占尽断肠花草。空留倩影，墨郎倾倒。怎识因啼缘笑。合数那、白练裙妍，试马弹丸人俏。辛未（1931）年长夏收此马、薛兰花小卷，清隽婉丽，真人间绝品也。因约遐庵拈韵题之。倚贺东山《望湘人》律谩书于后，吴湖帆。”</p>'
          },
          {
            x: 4271,
            y: 122,
            content: '<p>吴湖帆跋词：“丁丑（1937）正月十三日，天雨，闷坐小楼。青灯相对，读江灵鹣丈手书日记稿本。光绪廿一年（1895）年八月初六所填《金缕曲》，忆薛五事，又题马四娘画扇两绝句，因并录入此卷，亦可谓巧合也。《高阳台》误《金缕曲》。南部烟花，六朝金粉，何因重感深宵。十里秦淮，天教生此窈娆。宝弓细马黄金弹，任痴儿、看尽柔腰。又朝朝、九畹临风，着意轻描。当年风月今何处？賸画中爱宠，卷裹藏娇。一样湘兰，教人两样魂消。板桥总是伤心史，到如今、梦也无聊。更飘摇、燕子春灯，暮雨潇潇。元儿已老润娘归，胜国风流事已非。却记生绡双影在，一花一叶尚依稀。绝代名姝吊影单，素心虽小耐春寒。侬家拓得秦淮本，莫当烟花账簿看。丑簃漫录。”</p>'
          },
          {
            x: 1094,
            y: 287,
            content: '<p>吴湖帆题跋：“镜塘兄前年得马湘兰致王百榖八札真迹卷，缠绵悱恻，一往情深，洵不愧翠裹朱家红妆季布也。王马佳话传送奕世，覩八札而益信。恐马娇亲笔情书祇此孤本，清秦淮艷迹焉。余囊收此马薛画兰合卷，有朱竹垞、杨己军、钱箨石三家题字，并索诸友好歌词咏之，存于笈中，将二十年矣。因读八札，不禁起延津剑合之思，即以持赠镜塘。两卷合匮，或可留后世嗟谈助云。己丑（1949）秋九月八日，湖帆灯下识。”</p>'
          }
        ]
      }
    ]
  },
  'life4-51072': {
    caption: '明 王穉登 行书南还诗册',
    thumbnail: gallery['life4-51072-0.jpg'],
    description: '<p>隆庆二年（1568）</p><p>纸本 水墨</p><p>王穉登（1535-1612），字百榖，号半偈长者，江苏苏州人。此作书于1568年，作者时年三十四岁。</p><p>因王穉登与马守真（1548-1604）的爱情故事，吴湖帆将同时得于不同藏家的两人书画合装一册。在马氏画页上，吴湖帆题道：“王氏诗册为粤东伍俪荃旧藏，此画为吴荷屋物，余同时所得，皆粤物，故合装之。”又言“此画原夹在册内，疑当时伍氏所收未及装入者。”将相关书画比如“画中九友”、“金陵八家”汇集一册的偏爱，于吴湖帆尤为突出。</p>',
    slides: [
      {
        url: gallery['life4-51072-1.jpg'],
        points: [
          {
            x: 8960,
            y: 4560,
            content: '<p>吴湖帆题跋：“此画原夹在册内，疑当时伍氏所收未及装入者。湖帆志。”“万历丙子粤今三百六十年，重装于王百榖诗册上，丙子春日吴湖帆记。”“王氏诗册为粤东伍侣荃旧藏，此画为吴荷屋物，余同时所得，皆粤物，故合装之。”</p>'
          }
        ]
      },
      {
        url: gallery['life4-51072-2.jpg'],
        points: [
          {
            x: 297,
            y: 2030,
            content: '<p>吴湖帆题跋：“己巳六月得此册于李氏，同时并得马湘兰水仙小帧，附记于此，湖帆。”钤：“崇易居士”</p>'
          }
        ]
      },
      {
        url: gallery['life4-51072-3.jpg'],
        points: [
          {
            x: 4230,
            y: 462,
            content: '<p>吴湖帆册后题跋释文：吴湖帆（三题）：“己巳夏得王百榖手书诗稿一十有九叶，凡七十首，为董陇西书者。陇西爱之，每行与俱。后为吴幼玄所赏，遂以持去。崇祯间为季方者所得，倩娄苏庵续其后，历时文人护爱堪云备至。翁阁学二题皆为南海叶云谷书，旋归伍俪荃。鼎革后为李平书丈得于裴伯谦家者，余复收自李氏。此册之传可云线索自久矣，惜沪寓无百谷诗集一校为憾，吴湖帆记。”</p>'
          }
        ]
      }
    ]
  },
  'pen1-13834': {
    caption: '明 文征明 玉兰花图轴',
    thumbnail: gallery['pen1-13834-0.jpg'],
    description: '<p>嘉靖三十年（1551）</p><p>纸本 设色</p><p>文征明（1470-1559），字征仲，号衡山居士，长洲（今江苏苏州）人。此图为作者八十二岁作，受画人为无锡藏家华云。</p><p>据吴湖帆《丑簃日记》1938年5月7日记载，《玉兰图》为文征明名作，坊间伪本众多，而此本实为真迹。但“纸破不堪，千疮百孔，修补綦难，他人皆不敢购”，吴将此画留下 ，亲自动手补完 ，虽“接笔颇费力，然为保存名迹起见，不能避艰也。”</p>',
    slides: [
      {
        url: gallery['pen1-13834-1.jpg'],
        points: []
      }
    ]
  },
  'pen1-64755': {
    caption: '明 沈周 乔木慈乌图轴',
    thumbnail: gallery['pen1-64755-0.jpg'],
    description: '<p>纸本 水墨</p><p>《慈乌图》是沈周晚年的常作题材，一方面画慈乌有崇尚孝道的含义，另一方面也是沈周向明初画家林良学习的结果。</p><p>本图裱边吴湖帆跋中所提到的另一件家藏沈周《乔木双乌图》轴曾经其“全补”（见《吴湖帆日记》1935年1月），现同为上博藏品。细察之下，《乔木慈乌图》轴亦曾经高手全补，修补痕迹历历在目，手法十分高超。</p>',
    slides: [
      {
        url: gallery['pen1-64755-1.jpg'],
        points: []
      }
    ]
  },
  'pen1-31758': {
    caption: '元 赵孟頫 章草急就章册',
    thumbnail: gallery['pen1-31758-0.jpg'],
    description: '<p>至大二年（1309）</p><p>纸本 金笺</p><p>赵孟頫（1254-1322），字子昂，号松雪道人等。吴兴（今浙江湖州）人。此为传世赵孟頫《章草急就章》三本之一，作者时年五十六岁1929年5月，此册归吴湖帆收藏，吴氏补书第七开。</p>',
    slides: [
      {
        url: gallery['pen1-31758-1.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-2.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-3.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-4.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-5.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-6.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-7.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-8.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-9.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-10.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-11.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-12.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-13.jpg'],
        points: []
      },
      {
        url: gallery['pen1-31758-14.jpg'],
        points: [
          {
            x: 1392,
            y: 93,
            content: '<p>吴湖帆题跋释文：“谢池春慢。宋李端叔韵。挥毫驰阵，横扫继、征西后。狂素肯心降，颠旭（‘上’声）应眉皱。左揕吴生带，豪襻公孙袖。笑杨风，夸寝画。绿窗相对，如醉山阴酒。沤波画省，看小印、银钩瘦。北宋麝烟浓，蠹纸南唐旧。试问曾藏处，天籁青箱守。金错体，堪并偶。矫鹰吻厉，休话诚悬柳。己巳（1929）夏获此松雪《急就章》小册，戏拈一词，越今已廿年矣。庚寅春录之补空，是册每叶间有朱书数目祇一、三、五等单数字，心颇奇虑。后于故宫南迁书画，余参阅鉴审之役，得见俞紫芝小楷《急就章释文册》，宽广尺度及所用宋藏经纸与此悉同，而每叶间亦有朱书数目，为二、四、六等双数字，并纸角骑缝等处皆有项子京印记。乃悟原装一册，前半为赵书章草，后半为俞书释文，由项子京分装二册，不知何时离散，俞册入内府，赵册转转为余有矣。惟赵册第七帧缺去，余乃据《三希堂》刻本摹写一帧补入，以足完文云。吴湖帆识于迢迢阁。”</p>'
          }
        ]
      }
    ]
  },
  'pen1-45524': {
    caption: '元 王㽘等 诸家题倪瓒耕云轩咏卷',
    thumbnail: gallery['pen1-45524-0.jpg'],
    description: '<p>此卷原为倪云林为王㽘所画《耕耘轩图》，后有明代吴地诸贤题咏，清乾隆以后倪画佚失。吴湖帆得到后面的题咏后十分惋惜，遂据其意以倪氏笔法补画一图合装于前，笔墨冷隽萧散，甚得云林三味。</p>',
    slides: [
      {
        url: gallery['pen1-45524-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 12615,
            y: 569,
            content: '<p>吴湖帆题跋：“倪高士《耕云轩图》为照磨王㽘作，今卷祇存王㽘、卢熊、张适、高啓、僧衍（姚广孝）、徐达左、黄本七家诗跋及周天球、黄姬水、王穉登三题。据清高宗三跋云：懒瓉此图笔意萧散，足传高致。可知真迹在乾隆间尚未佚也。因揣意补此以冀剑合时。己卯（1939）五月吴湖帆作于双修阁。”</p>'
          }
        ]
      }
    ]
  },
  'pen1-19800': {
    caption: '明 董其昌 画禅室小景图册',
    thumbnail: gallery['pen1-19800-0.jpg'],
    description: '<p>对自己喜欢的藏品，吴湖帆往往反复题跋，除了一些鉴定或考证的文字外，亦多有诗词或书画之作。如此册的板面背绢上即以董氏风格戏作小景一帧，笔墨气韵与原作极为相近，吴自称此等行为“恐自古未有”，得意之情跃然纸上。</p>',
    slides: [
      {
        url: gallery['pen1-19800-1.jpg'],
        points: []
      },
      {
        url: gallery['pen1-19800-2.jpg'],
        points: []
      }
    ]
  },
  'pen1-45531': {
    caption: '吴湖帆补《北宋 米芾 行书多景楼诗册》册前页',
    thumbnail: gallery['pen1-45531-0.jpg'],
    description: '<p>这是吴湖帆根据《多景楼》诗意为米芾这件名作配画的画页，以灵活的笔墨图写北固山上多景楼临江独峙的高旷寥廓之景，点染潇洒，颇有米氏风韵，亦足见吴对这件作品的珍视之心。</p>',
    slides: [
      {
        url: gallery['pen1-45531-1.jpg'],
        points: []
      },
      {
        url: gallery['pen1-45531-2.jpg'],
        points: [
          {
            x: 608,
            y: 82,
            content: '<p>吴湖帆题跋：“取南宫意境，写北固江山于大米《多景楼诗》真迹册首，亦八百年来文字缘也。吴湖帆识，乙巳（1965）重阳。”</p>'
          }
        ]
      }
    ]
  },
  'pen1-45534': {
    caption: '吴湖帆《梅景书屋图》',
    thumbnail: gallery['pen1-45534-0.jpg'],
    description: '<p>这是吴湖帆为自己的书斋梅景书屋所绘画页，布局仿南宋院本之制，设色妍雅，渲染清润，气息恬静怡然。画成后与其自制《十六字令》共同由装裱名家刘定之补装入《梅花喜神谱》中。</p>',
    slides: [
      {
        url: gallery['pen1-45534-1.jpg'],
        points: []
      },
      {
        url: gallery['pen1-45534-2.jpg'],
        points: []
      }
    ]
  },
  'pen1-59917': {
    caption: '吴湖帆补《 宋拓 梁萧敷敬妃墓志铭合册》册首页',
    thumbnail: gallery['pen1-59917-0.jpg'],
    description: '<p>对于自己心爱的藏品，吴湖帆往往欣然命笔以诗词、绘画的形式品评赞叹，抒发喜爱之情，且每以与藏品相关的笔法、风格出之，如《多景楼图》以米氏风格点染，《梅景书屋》出以宋院体格局，《画禅室小景补图》仿董其昌笔墨等。《 宋拓 梁萧敷敬妃墓志铭合册》亦为吴氏家传之珍，尤所偏爱，因其原石为六朝遗物，故吴湖帆于册前作青绿山水一页，以“张僧鹞法”图写，笔法精细，设色大胆，而能艳不伤雅，颇得高古气韵。</p>',
    slides: [
      {
        url: gallery['pen1-59917-1.jpg'],
        points: []
      },
      {
        url: gallery['pen1-59917-2.jpg'],
        points: []
      }
    ]
  },
  'pen2-45518': {
    caption: '罗聘、方婉仪 吴湖帆、潘静淑 梅花合作图卷',
    thumbnail: gallery['pen2-45518-0.jpg'],
    description: '<p>乾隆二十八年（1763） 民国二十五年（1936）</p><p>纸本 设色</p><p>罗聘（1733-1799），字遯夫，号花之寺僧。安徽歙县人，迁居扬州。“扬州八怪”之一。方婉仪（1732—1784后）一作畹仪，字仪子，号白莲居士等，安徽歙县人。罗聘妻子。</p><p>吴湖帆夫妇志趣相投，于诗词书画之道用心甚深，不但共同鉴藏，更常合作题写染翰。1936年，吴湖帆得罗聘、方婉仪夫妇合作《梅花图》卷，即罗聘以王冕繁梅之法所绘，其妻方婉仪以画面不甚分明，取牵牛花浸汁渍染花瓣，使之一目了然。吴氏夫妻追慕前人韵事，亦合作一卷装裱其后，潘静淑点缀梅花，吴湖帆补写枝干月影，越百年而再赋画眉添香、唱随于飞之雅调，洵为佳话。</p>',
    slides: [
      {
        url: gallery['pen2-45518-1.jpg'],
        zoomLevel: 10,
        points: [
          {
            x: 13381,
            y: 218,
            content: '<p>罗聘题跋：“……别有风光不受春，画毕自看还自惜。问到底赠何人花。癸未（1763）夏六月仿王元章繁枝梅花，赵子固云：浓墨点椒，大是难事。予画此卷，三日始成。内子白莲，展观再四，嫌其不甚分明，晨起乃摘牵牛花，浸汁渍其花瓣，令观者一目了然。予不可不记其苦心也。甲申（1764）四月舟过古丰□题，朱草诗林中人罗聘。</p>'
          },
          {
            x: 13770,
            y: 52,
            content: '<p>“此卷所用之纸，乃两峰画之特征。往往金冬心画亦用此纸，然多出于两峰代作。冬心亲笔画鲜用此纸，而他人绝无用之者。白莲女史或用之，故此纸特命之曰‘两峰纸’可也。白莲画颇柔美，其苍劲一种，都出两峰之笔，往往亦用此纸。王元章好画繁枝直榦，此卷深具神似，白莲染色尤韵致。”</p>'
          },
          {
            x: 8210,
            y: 98,
            content: '<p>“疏景黄榦。近见宋画《月影梅花》纨扇，展其意作此图，余写枝干月影。时丙子中秋，吴湖帆识。”</p>'
          },
          {
            x: 7835,
            y: 77,
            content: '<p>吴湖帆题跋：“静淑缀绿萼花百朵于梅景书屋。”钤：“吴潘静淑”白文方印，“梅景书屋”朱文方印。</p>'
          }
        ]
      }
    ]
  },
  'pen2-47811': {
    caption: '郑慕康、吴湖帆、陆俨少 刘定之像卷',
    thumbnail: gallery['pen2-47811-0.jpg'],
    description: '<p>乙未（1955）</p><p>纸本 设色</p><p>刘定之是民国时期书画装池大家，他开设的“刘定之装池”，闻名海上。1949年后，刘氏参加上海市装裱业同业公会，1960年进入上海博物馆任文物修复顾问，后至北京。上博与故宫诸多传世名迹如张择端《清明上河图》卷、孙位《高逸图》卷等皆出其手。</p><p>刘定之的装裱工艺独特、技术高超、用料讲究，吴湖帆的许多重要藏品如《梅花喜神谱》册、倪瓒《汀树遥岑图》轴等皆由其亲自操刀，刘氏也因此与书画家结下深厚的友谊。此卷由当时著名肖像画家郑慕康所作，由陆俨少、周炼霞、俞子才、何遂等诸家补阑干树石翎毛，吴湖帆题写卷首，可谓集一时之胜。</p>',
    slides: [
      {
        url: gallery['pen2-47811-1.jpg'],
        zoomLevel: 2,
        points: []
      },
      {
        url: gallery['pen2-47811-2.jpg'],
        zoomLevel: 5,
        points: [
          {
            x: 4800,
            y: 84,
            content: '<p>吴湖帆题跋：“老友勾曲刘先生定之，具精装书画之术，五十余年中经其妙手潢治而得还旧观者，不知几千百事。昔项墨林尊当时潢池名家曰书画神医，殆非虚誉。定之先生出郑君慕康造六十七岁像，索余补图引书卷端。乙未（1955）清明，吴湖帆。”</p>'
          }
        ]
      }
    ]
  },
  'pen2-61174': {
    caption: '吴湖帆 松风鸣泉图轴',
    thumbnail: gallery['pen2-61174-0.jpg'],
    description: '<p>癸巳（1953）</p><p>纸本 水墨</p><p>本图纯用水墨，以不同的墨色营造出幽深的意境。远景崇山峻岭，以淡墨晕染，近景用浓墨勾勒两株参天古松，辅以层层皴染的山石，水墨淋漓，宛若天成。一旁山泉飞流直下，一静一动形成强烈对比，独具匠心。吴湖帆在传统和创新之间，走出自己的艺术道路，形成清宁雅丽、精致深秀的绘画风格。此图作于癸巳（1953），吴湖帆时年六十岁。</p>',
    slides: [
      {
        url: gallery['pen2-61174-1.jpg'],
        points: []
      }
    ]
  },
  'pen2-67596': {
    caption: '吴湖帆 层岩积翠图轴',
    thumbnail: gallery['pen2-67596-0.jpg'],
    description: '<p>民国三十三年（1944）</p><p>纸本 设色</p><p>此图是吴湖帆青绿山水的代表作。图中描绘深山岩树的景致。近景的丛树纯用水墨，以不同的墨色营造出幽深的氛围。而山石则先以墨色为底，皴染出结构，再用极淡的色彩层层烘染，最后形成色墨互不相碍且相互生发的效果。因为这种新颖的设色技巧，使吴湖帆的青绿山水既有传统青绿山水鲜明的色彩，又保有水墨山水丰富的笔墨变化，形成妍丽而文雅、深厚而清秀的独特画风。此图作于1944年，作者时年五十一岁。</p>',
    slides: [
      {
        url: gallery['pen2-67596-1.jpg'],
        points: []
      }
    ]
  },
  'pen2-72444': {
    caption: '吴湖帆 梅景书屋图轴',
    thumbnail: gallery['pen2-72444-0.jpg'],
    description: '<p>民国十八年（1929）</p><p>纸本 设色</p><p>此图为吴湖帆三十六岁所绘，出以唐寅笔法。图中山涧幽谷，白梅万点，茅屋掩映其间。室内有一雅士与女史凭案对坐，当为吴氏夫妻自况。</p><p>裱边为吴湖帆、潘静淑伉俪集选南宋词人吴文英《梦窗词》句，据《瑞鹤仙》和《烛影摇红》词牌所填新词，与图画情景相得益彰。二词另见于刘定之为吴湖帆重装的《梅花喜神谱》册内。</p>',
    slides: [
      {
        url: gallery['pen2-72444-1.jpg'],
        points: []
      }
    ]
  },
  'pen2-72519': {
    caption: '吴湖帆 仿燕文贵溪山楼观图轴',
    thumbnail: gallery['pen2-72519-0.jpg'],
    description: '<p>民国二十四年（1935）</p><p>纸本 设色</p><p>此图为吴湖帆仿北宋画家燕文贵（967-1044）画作。图绘远山巍峨，层峦叠嶂，云气蒸腾。近景古松遒劲，溪水潺潺。吴湖帆四十一岁成为故宫博物院审查委员，所见宋元名迹甚多。过眼之余，其于摹写又能形神俱似，笔益精炼，神明焕然，画乃益进。吴湖帆在艺术创作上善于融会贯通，其深植在心底的根基还是宋</p>',
    slides: [
      {
        url: gallery['pen2-72519-1.jpg'],
        points: []
      }
    ]
  },
  'pen2-73413': {
    caption: '吴湖帆 湖山秋色图轴',
    thumbnail: gallery['pen2-73413-0.jpg'],
    description: '<p>民国二十一年（1932）</p><p>纸本 设色</p><p>吴湖帆山水从董其昌、“四王”出，早期作品受到的影响尤深。此图作于 1932年，吴湖帆时年三十九岁，正是其山水画法发生变化，逐渐形成自身风格的时期。此图虽云学董其昌</p><p>与王鉴，其构图布景、山石形貌也确是华亭、“四王”家法，但其笔墨却已变董、王之清透而为腴秀，化生拙为绵厚，吴氏面貌已然呼之欲出。</p>',
    slides: [
      {
        url: gallery['pen2-73413-1.jpg'],
        points: []
      }
    ]
  },
  'pen2-75947': {
    caption: '吴湖帆 梅花图扇页',
    thumbnail: gallery['pen2-75947-0.jpg'],
    description: '<p>民国二十年（1931）</p><p>纸本 水墨/设色</p><p>吴湖帆斋号“梅景书屋”，其与梅花有关的最著名藏品是宋刻《梅花喜神谱》。除此之外，吴湖帆亦留意收藏古今画家的梅花作品，自己也喜作梅花。此四开梅花扇面是吴湖帆为友朋所作，两开水墨，笔墨清雅中见沉腴；两开设色，色泽明净中见娇美。每开分别配题姜夔、周邦彦、史达祖、吴文英梅花词一句，虽为小品，亦可见其匠心与文心。此图作于1931年，作者时年三十八岁。</p>',
    slides: [
      {
        url: gallery['pen2-75947-1.jpg'],
        points: []
      },
      {
        url: gallery['pen2-75947-2.jpg'],
        points: []
      },
      {
        url: gallery['pen2-75947-3.jpg'],
        points: []
      },
      {
        url: gallery['pen2-75947-4.jpg'],
        points: []
      }
    ]
  },
  'pen2-78124': {
    caption: '吴湖帆 写小方壶石像轴',
    thumbnail: gallery['pen2-78124-0.jpg'],
    description: '<p>辛卯（1951）</p><p>纸本 设色</p><p>王一平捐赠</p><p>图绘小方壶石，色彩雅丽，栩栩如生。此图作于1951年，作者时年五十八岁。此图经王一平（1914-2007，曾任中共上海市委书记）鉴藏。</p>',
    slides: [
      {
        url: gallery['pen2-78124-1.jpg'],
        points: []
      },
      {
        url: gallery['pen2-78124-2.jpg'],
        points: [
          {
            x: 1737,
            y: 165,
            content: '<p>王一平捐赠</p><p>高凤翰（1683-1748），字西园，号南村，晚号南阜，山东胶县人。</p><p>此石属石英砂岩类，作山形，上刻“小方壶”和草书“丙寅秋日南阜左手制”。底座上有“宋坑小方壶”名，并题刻“南阜旧藏小方壶，石浓翠欲滴，宋坑中奇品也，镜塘兄获之，为数青草堂益友。辛卯冬，吴湖帆题”。可知此石原为高凤翰收藏，后为收藏家钱镜塘所获。</p>'
          }
        ]
      }
    ]
  },
  extra: {
    home1: {
      toHomeBtn,
      caption: '吴大澂（1835～1902）',
      description: '<p>初名大淳，字止敬，又字清卿，号恒轩，晚年又号愙斋，江苏省吴县（今江苏苏州）人。清代学者、金石学家、书画家，曾任广东、湖南巡抚，著有《说文古籀补》、《古玉图考》、《权衡度量考》、《愙斋集古录》、《恒轩所见所藏吉金录》、《愙斋文集》等。</p>'
    },
    home2: {
      toHomeBtn,
      caption: '沈树镛',
      description: '<p>号韵初。川沙城镇人。清咸丰九年（1859年）中举。博学多才，官至内阁中书。嗜金石、碑帖、书画，善鉴定、收藏甚富，亦作书画。碑版文字考订精辟，所藏秘籍珍本极丰，有“富甲东南”之誉。</p>'
    },
    home3: {
      toHomeBtn,
      caption: '潘祖荫（1830～1890年）',
      description: '<p>字伯寅，清代苏州府吴县人。咸丰二年（1852）壬子科探花，授翰林院编修，历任刑部、工部尚书，官至军机大臣。</p><p>潘祖荫自幼涉猎百家，精通经史，工书法，好收藏，尤嗜书画、版本和金石。他还是位金石、版本学家，曾辑有《攀古楼金石款识》二卷，并著成《滂喜斋读书记》二卷，《滂喜斋宋元本书目》一卷，曾刊有《滂喜斋丛书》、《功顺堂丛书》。</p>'
    },
    home4: {
      toHomeBtn,
      caption: '吴湖帆（1894-1968）',
      description: '<p>初名翼燕，字遹骏，后更名万，字东庄，别署丑簃，又改名倩，字倩庵，书画署名湖帆，斋名“梅景书屋”，苏州人。潘静淑（1892-1939），名树春，吴湖帆夫人。</p>'
    },
    sight: {
      toHomeBtn,
      caption: '眼光与识见',
      description: ''
    }
  }
}

_.forIn(data, function(v, k) {
  if (v.references) {
    data[k] = data[v.references]
  }
})

export default data
